{
  "nav.customers": "Customers",
  "nav.products": "Products",
  "nav.orders": "Orders",
  "nav.drivers": "Drivers",
  "nav.driverProfiles": "Driver Profiles",
  "nav.userManagement": "Members & Permissions",
  "nav.dispatch": "Logistics",
  "nav.overview": "Overview",
  "nav.jobs": "Delivery Jobs",
  "nav.reviewQueue": "Operator Inbox",
  "nav.packaging": "Delivery Job Printout",
  "routePlanning.title": "Routes",
  "routePlanning.description": "Review delivery routes, geocoded stops, and delivery jobs that still need coordinates.",
  "routePlanning.date": "Delivery date",
  "routePlanning.loading": "Loading routes…",
  "routePlanning.error": "Could not load routes.",
  "routePlanning.etaError": "Live driver data unavailable — the map may be showing stale assignments.",
  "routePlanning.stopCount_one": "{{count}} mapped stop",
  "routePlanning.stopCount_other": "{{count}} mapped stops",
  "routePlanning.sidebarTitle": "Route ETAs",
  "routePlanning.todayOnlyNotice": "Live route monitoring and driver location are only available for today's delivery date.",
  "routePlanning.liveMonitoringActive_one": "Live monitoring {{count}} driver",
  "routePlanning.liveMonitoringActive_other": "Live monitoring {{count}} drivers",
  "routePlanning.missing.title": "No-coordinate delivery jobs",
  "routePlanning.missingCount": "{{count}} missing",
  "routePlanning.missingReason.order_not_found": "Order not found",
  "routePlanning.missingReason.no_address": "No shipping address",
  "routePlanning.missingReason.unresolved": "Coordinates could not be resolved",
  "routePlanning.unknownOrder": "Unknown order",
  "routePlanning.popup.order": "Order",
  "routePlanning.popup.driver": "Driver",
  "routePlanning.popup.zip": "ZIP",
  "routePlanning.popup.status": "Status",
  "routePlanning.popup.completedAt": "Delivered",
  "routePlanning.popup.eta": "ETA",
  "routePlanning.map.ariaLabel": "Route-planning map",
  "routePlanning.driver.offDuty": "Off duty",
  "routePlanning.driver.lastSeen": "{{minutes}} min ago",
  "routePlanning.driver.onlyDriver": "Only {{name}}",
  "routePlanning.driver.showAll": "Show all",
  "routePlanning.driver.toggleTasks": "Show or hide driver tasks",
  "routePlanning.filter.placeholder": "Find a driver task (e.g. #87201HGS-0914)",
  "routePlanning.filter.noMatch": "No matching driver task",
  "routePlanning.openJobDetail": "Open delivery job",
  "routePlanning.unlinked.notInTodayStops": "Not in today's stops",
  "routePlanning.unlinked.notInTodayStopsHint": "This driver task's id matches no delivery job stop for today, so it cannot be placed on the route.",
  "routePlanning.fullscreen.enter": "Enter fullscreen",
  "routePlanning.fullscreen.exit": "Exit fullscreen",
  "routePlanning.legend.title": "Legend",
  "routePlanning.legend.delivered": "Delivered (driver colour)",
  "routePlanning.legend.pending": "To deliver (hollow)",
  "routePlanning.legend.unassigned": "No driver (grey)",
  "routePlanning.legend.unknown": "Awaiting live data (grey ring)",
  "routePlanning.legend.driver": "Driver position (grey when stale)",
  "routePlanning.legend.routeDone": "Solid: already covered",
  "routePlanning.legend.routePending": "Dashed: still to run",
  "routePlanning.unassigned.title": "Unassigned stops",
  "routePlanning.unassignedCount_one": "{{count}} stop",
  "routePlanning.unassignedCount_other": "{{count}} stops",
  "audit.pageTitle": "Audit Log",
  "webhooks.pageTitle": "Webhooks",
  "audit.filtersTitle": "Filters",
  "audit.routeLabel": "Route",
  "audit.routePlaceholder": "/api/orders/:id/cancel",
  "audit.actorLabel": "Actor",
  "audit.actorPlaceholder": "user_abc123",
  "audit.fromLabel": "From",
  "audit.toLabel": "To",
  "audit.unavailableNote": "The route filter matches the exact API path; free-text search and a source filter are not available on the audit ledger.",
  "audit.loadFailed": "Failed to load audit entries.",
  "audit.resetFilters": "Reset filters",
  "audit.colTimestamp": "Timestamp",
  "audit.colActor": "Actor",
  "audit.colMethod": "Method",
  "audit.colRoute": "Route",
  "audit.colOutcome": "Outcome",
  "audit.outcome.ok": "OK",
  "audit.outcome.error": "Error",
  "audit.empty": "No audit entries match the current filters.",
  "audit.pagerHint": "Page {{page}}",
  "audit.prev": "Previous",
  "audit.next": "Next",
  "audit.requestPath": "Request path",
  "audit.permission": "Permission",
  "audit.errorMessage": "Error",
  "audit.traceId": "Trace ID",
  "audit.created": "Created",
  "audit.updated": "Updated",
  "audit.deleted": "Deleted",
  "audit.restored": "Restored",
  "audit.justNow": "just now",
  "audit.minutesAgo": "{{count}}m ago",
  "audit.hoursAgo": "{{count}}h ago",
  "audit.daysAgo": "{{count}}d ago",
  "audit.recordCreated": "Record created",
  "audit.recordDeleted": "Record deleted",
  "audit.recordUpdated": "Record updated",
  "audit.recordRestored": "Record restored",
  "audit.initialValues": "Initial values",
  "audit.deletedRecord": "Deleted record",
  "audit.changes": "Changes",
  "audit.noChanges": "No changes recorded",
  "audit.jsonDiff.fieldsChanged_one": "{{count}} field changed",
  "audit.jsonDiff.fieldsChanged_other": "{{count}} fields changed",
  "audit.jsonDiff.equivalent": "No field values changed (serialization only)",
  "audit.jsonDiff.viewRaw": "View raw JSON",
  "audit.loadMore": "Load more",
  "audit.loadingMore": "Loading…",
  "audit.showingAll_one": "All {{count}} change loaded",
  "audit.showingAll_other": "All {{count}} changes loaded",
  "audit.shopifyActor.ask": "Look up Shopify activity",
  "audit.shopifyActor.loading": "Asking Shopify…",
  "audit.shopifyActor.scope": "Shopify attributes who created, published, unpublished or changed a record's status, and who changed a customer's email or phone. Other field edits — a price, a title, an address — are not attributable: Shopify keeps no record of who made them.",
  "audit.shopifyActor.failed": "Could not reach Shopify. No attribution was loaded — this does not mean nobody touched the record.",
  "audit.shopifyActor.srLabel": "Shopify operator",
  "audit.updated.summary": "Updated {{field}}",
  "audit.restored.summary": "Restored {{field}}",
  "audit.more": "+{{count}} more",
  "audit.actor.system": "System",
  "audit.actor.cron": "Scheduled job",
  "audit.actor.backfill": "Backfill job",
  "audit.actor.smoke": "Smoke test",
  "audit.actor.unknown": "Unknown user",
  "audit.actor.systemHint": "Non-user actor (system, webhook, or scheduled job)",
  "audit.actor.srLabel": "Actor",
  "audit.time.srLabel": "Updated at",
  "audit.actor.shopifyWebhook": "Shopify webhook",
  "audit.actor.shopifyWebhookWithEvent": "Shopify · {{event}}",
  "audit.actor.onfleetWebhook": "Onfleet webhook",
  "audit.actor.onfleetWebhookWithEvent": "Onfleet · {{event}}",
  "audit.actor.manualUnattributed": "Manual (actor unattributed)",
  "audit.tab.requests.description": "Who called which privileged API, when, and with what outcome — requests, not data.",
  "audit.tab.changes.description": "Which field of which record became what, and which person or webhook caused it — the data change itself.",
  "audit.colResourceType": "Resource type",
  "audit.colResource": "Resource",
  "audit.colAction": "Action",
  "audit.colSource": "Source",
  "audit.colChangeSummary": "Change summary",
  "audit.resourceType.orders": "Order",
  "audit.resourceType.customers": "Customer",
  "audit.resourceType.products": "Product",
  "audit.resourceType.fulfillment_jobs": "Delivery Job",
  "audit.resourceType.tenant_settings": "Tenant Settings",
  "audit.source.manual": "Manual",
  "audit.source.shopify_webhook": "Shopify webhook",
  "audit.source.onfleet_webhook": "Onfleet webhook",
  "audit.source.cron": "Scheduled job",
  "audit.source.backfill": "Backfill job",
  "audit.source.smoke": "Smoke test",
  "webhookHealth.title": "Webhook Health",
  "webhookHealth.subtitle": "Per-topic webhook delivery health over the selected window, derived from recorded events. Silent (0-event) declared topics and undeclared drift topics are the signals to watch.",
  "webhookHealth.onfleet.title": "Onfleet — Last Reconcile Snapshot",
  "webhookHealth.onfleet.deliveryTitle": "Onfleet — Per-Topic Delivery Health",
  "webhookHealth.refresh": "Refresh",
  "webhookHealth.reconcileNow": "Reconcile now",
  "webhookHealth.loading": "Loading…",
  "webhookHealth.empty": "No reconcile snapshot yet — run reconcile to populate this view.",
  "webhookHealth.lastReconciled": "Last reconciled",
  "webhookHealth.active": "Active",
  "webhookHealth.reconcileErrors": "Reconcile errors",
  "webhookHealth.table.name": "Name",
  "webhookHealth.table.trigger": "Trigger",
  "webhookHealth.table.status": "Status",
  "webhookHealth.table.count": "Successful deliveries",
  "webhookHealth.table.id": "Onfleet ID",
  "webhookHealth.status.ok": "OK",
  "webhookHealth.status.created": "Created",
  "webhookHealth.status.rebuilt": "Rebuilt",
  "webhookHealth.status.error": "Error",
  "webhookHealth.status.disabled": "Disabled",
  "webhookHealth.toast.reconciled": "Reconcile complete",
  "webhookHealth.error": "Webhook health request failed",
  "webhookHealth.shopify.title": "Shopify — Per-Topic Delivery Health",
  "webhookHealth.shopify.window": "Window",
  "webhookHealth.shopify.windowHours": "Last {{hours}}h",
  "webhookHealth.shopify.windowSwitcher.label": "Window",
  "webhookHealth.shopify.windowSwitcher.6h": "6h",
  "webhookHealth.shopify.windowSwitcher.24h": "24h",
  "webhookHealth.shopify.windowSwitcher.3d": "3d",
  "webhookHealth.shopify.windowSwitcher.7d": "7d",
  "webhookHealth.shopify.windowSwitcher.30d": "30d",
  "webhookHealth.shopify.totals.events": "Declared events",
  "webhookHealth.shopify.totals.errorRate": "Declared error rate",
  "webhookHealth.shopify.driftAlert": "Subscription drift detected — at least one received topic is not in the application's declared handler set. Review this provider's webhook subscriptions.",
  "webhookHealth.shopify.table.topic": "Topic",
  "webhookHealth.shopify.table.status": "Status",
  "webhookHealth.shopify.table.total": "Total",
  "webhookHealth.shopify.table.completed": "Completed",
  "webhookHealth.shopify.table.success": "Success",
  "webhookHealth.shopify.table.failed": "Failed",
  "webhookHealth.shopify.table.errorRate": "Error rate",
  "webhookHealth.shopify.table.lastSeen": "Last seen",
  "webhookHealth.shopify.table.lastError": "Last error",
  "webhookHealth.shopify.status.healthy": "Healthy",
  "webhookHealth.shopify.status.degraded": "Degraded",
  "webhookHealth.shopify.status.unhealthy": "Unhealthy",
  "webhookHealth.shopify.status.silent": "Silent",
  "webhookHealth.shopify.status.drift": "Drift",
  "webhookHealth.shopify.emptyError": "(no message recorded)",
  "nav.kitchen": "Kitchen",
  "nav.workbench": "Workbench",
  "nav.delivery": "Delivery",
  "nav.ordersProducts": "Orders & Products",
  "nav.sidebarTitle": "Navigation",
  "nav.driversAndProfiles": "Drivers & Profiles",
  "nav.audit": "Audit",
  "nav.webhooks": "Webhooks",
  "nav.kitchen.dishesCombos": "Dishes & Combos",
  "nav.kitchen.ingredientsStock": "Ingredients & Stock",
  "nav.kitchen.procurementSuppliers": "Procurement & Suppliers",
  "nav.openMenu": "Toggle navigation",
  "theme.toggle": "Toggle theme",
  "language.switch": "Switch language",
  "shell.clock": "{{weekday}} {{date}} · {{time}} {{zone}}",
  "shell.phoneToday": "Today {{weekday}} {{md}} · {{time}} {{zone}}",
  "mobileNav.label": "Bottom navigation",
  "mobileNav.now": "Now",
  "mobileNav.jobs": "Jobs",
  "mobileNav.inbox": "Inbox",
  "mobileNav.more": "More",
  "nav.management": "Settings",
  "nav.admin": "Admin",
  "nav.profile": "Profile",
  "nav.logout": "Logout",
  "nav.brandSubtitle": "Operations console",
  "ui.loading": "Loading...",
  "ui.today": "Today",
  "ui.relativeEta.imminent": "Arriving now",
  "ui.relativeEta.minutes": "~{{minutes}} min",
  "ui.relativeEta.hours": "~{{hours}}h",
  "ui.relativeEta.hoursMinutes": "~{{hours}}h {{minutes}}m",
  "ui.relativeEta.overdue": "{{minutes}} min late",
  "ui.loadingMore": "Load more",
  "ui.noData": "No data",
  "ui.openInShopify": "Open in Shopify",
  "ui.openInOnfleet": "Open in Onfleet",
  "ui.save": "Save",
  "ui.cancel": "Cancel",
  "ui.confirm": "Confirm",
  "ui.view": "View",
  "ui.export": "Export",
  "ui.filter": "Filter",
  "ui.clear": "Clear",
  "ui.selectAll": "Select all",
  "ui.refresh": "Refresh",
  "ui.retry": "Retry",
  "ui.back": "Back",
  "ui.next": "Next",
  "ui.previous": "Previous",
  "ui.submit": "Submit",
  "ui.close": "Close",
  "ui.processing": "Processing...",
  "ui.ok": "OK",
  "ui.on": "On",
  "ui.off": "Off",
  "ui.none": "None",
  "ui.done": "Done",
  "ui.refreshPage": "Refresh page",
  "ui.usingDefault": "(using environment default)",
  "ui.currentValue": "Current value: ",
  "form.name": "Name",
  "form.phone": "Phone",
  "form.email": "Email",
  "form.address": "Address",
  "form.status": "Status",
  "form.date": "Date",
  "form.time": "Time",
  "form.notes": "Notes",
  "form.description": "Description",
  "form.startDate": "Start date",
  "form.endDate": "End date",
  "form.fromDate": "From date",
  "form.toDate": "To date",
  "form.worker": "Driver",
  "form.vehicle": "Vehicle",
  "form.location": "Location",
  "error.network": "Network connection failed. Please check your settings.",
  "error.server": "Server error. Please try again later.",
  "error.validation": "Validation failed. Please check your input.",
  "error.notFound": "Data not found.",
  "error.unauthorized": "Access denied.",
  "error.forbidden": "Action forbidden.",
  "error.internal": "Something went wrong on our side. Please try again later.",
  "error.timeout": "Request timed out. Please try again.",
  "error.unknown": "Unknown error.",
  "error.futureDate": "Onfleet API does not support future start dates. Please select today or an earlier date.",
  "error.appError": "Application error",
  "error.appErrorMessage": "Sorry, the application encountered an error. Please try refreshing the page.",
  "error.errorDetails": "Error details (dev mode)",
  "error.loadFailed": "Failed to load",
  "error.saveFailed": "Failed to save",
  "error.code.VALIDATION_FAILED": "Validation failed. Please check your input.",
  "error.code.UNAUTHORIZED": "Your session has expired. Please sign in again.",
  "error.code.FORBIDDEN": "You do not have permission to perform this action.",
  "error.code.NOT_FOUND": "The requested resource was not found.",
  "error.code.METHOD_NOT_ALLOWED": "This action is not allowed.",
  "error.code.CONFLICT": "This conflicts with the current state. Please refresh and try again.",
  "error.code.LOCKED": "This resource is locked by another operation. Please try again shortly.",
  "error.code.RATE_LIMITED": "Too many requests. Please slow down and try again.",
  "error.code.REQUEST_FAILED": "The request could not be completed.",
  "error.code.INTERNAL": "Something went wrong on our side. Please try again later.",
  "error.code.ONFLEET_OUTBOUND_FAILED": "The delivery provider rejected the request.",
  "error.code.REPLAY_PAYLOAD_UNAVAILABLE": "The original webhook payload is no longer available to replay.",
  "error.code.MAINTENANCE": "The system is under maintenance. Please try again in a few minutes.",
  "success.save": "Saved successfully",
  "success.delete": "Deleted successfully",
  "success.export": "Exported successfully",
  "success.update": "Updated successfully",
  "success.upload": "Uploaded successfully",
  "table.rows": "rows",
  "table.page": "Page",
  "table.of": "of",
  "table.showing": "Showing",
  "table.noResults": "No data",
  "table.loadMore": "Load more",
  "table.allDataLoaded": "All data loaded",
  "task.unassigned": "Unassigned",
  "task.assigned": "Assigned",
  "task.active": "Active",
  "task.completed": "Completed",
  "task.unknown": "Unknown",
  "task.refetch.sectionTitle": "Re-fetch from Onfleet",
  "task.refetch.sectionDescription": "Pull this driver task's latest state from Onfleet and re-apply it locally. Use when a webhook may have been missed.",
  "task.refetch.button": "Re-fetch from Onfleet",
  "task.refetch.success.title": "Re-fetch complete",
  "task.refetch.success.applied": "Driver task refreshed from Onfleet (status: {{status}}).",
  "task.refetch.success.stale": "Onfleet has no newer state than what is already stored. Nothing to update.",
  "task.refetch.success.terminal": "The local driver task is already in a terminal state ({{status}}). Onfleet state was not re-applied.",
  "task.refetch.success.illegal": "Onfleet state ({{to}}) is not a legal transition from local state ({{from}}). Refresh skipped.",
  "task.refetch.error.title": "Re-fetch failed",
  "task.refetch.error.notFound": "Onfleet reports this driver task does not exist. It may have been deleted or the id is wrong.",
  "task.refetch.error.unknownTask": "Onfleet has this driver task but Fastcade has no matching delivery job. It may have been created outside this system.",
  "task.refetch.error.unknown": "Could not reach Onfleet. Detail: {{detail}}",
  "worker.accepted": "Accepted",
  "worker.invited": "Invited",
  "worker.suspended": "Suspended",
  "auth.login.title": "Sign in",
  "auth.login.email": "Work email",
  "auth.login.password": "Password",
  "auth.login.forgotPassword": "Forgot password?",
  "auth.login.submitting": "Signing in...",
  "auth.login.submit": "Sign in",
  "auth.login.noAccount": "Don't have an account?",
  "auth.login.signUp": "Sign up",
  "auth.login.emailNotVerified": "Your email is not verified yet. A verification email has been sent.",
  "auth.login.emailNotVerifiedHint": "Check your inbox (and spam folder) for the verification link.",
  "auth.login.resendVerification": "Resend verification email",
  "auth.login.resendingVerification": "Sending...",
  "auth.login.verificationResent": "Verification email sent!",
  "auth.login.heroTitle": "Sign in to run your delivery day.",
  "auth.login.heroLead": "Orders, pick lists, routes and drivers for your store, in one place.",
  "auth.login.stationsLabel": "A delivery day in Fastcade",
  "auth.login.station.ordersIn": "Orders come in",
  "auth.login.station.pickList": "Pick list",
  "auth.login.station.routes": "Routes",
  "auth.login.station.driversOut": "Drivers head out",
  "auth.login.station.delivered": "Delivered",
  "auth.login.invalidCredentialsTitle": "That email and password do not match.",
  "auth.login.invalidCredentialsBody": "Check both and try again, or reset your password.",
  "auth.login.inviteOnly": "Fastcade is invitation-only. Ask your store admin for an invitation, or",
  "auth.login.requestAccess": "request access at fastcade.com.",
  "auth.login.requestAccessHref": "https://fastcade.com/#access",
  "auth.shell.languageNav": "Language",
  "auth.shell.privacy": "Privacy",
  "auth.shell.privacyHref": "https://fastcade.com/privacy/",
  "auth.shell.terms": "Terms",
  "auth.shell.termsHref": "https://fastcade.com/terms/",
  "auth.forgot.title": "Forgot password",
  "auth.forgot.subtitle": "Enter your registered email and we'll send a reset link",
  "auth.forgot.email": "Email",
  "auth.forgot.submitting": "Sending...",
  "auth.forgot.submit": "Send reset link",
  "auth.forgot.success": "Email sent",
  "auth.forgot.successMessage": "If that email is registered, you'll receive a password reset email. Check your inbox (and spam folder).",
  "auth.forgot.backToLogin": "Back to sign in",
  "auth.reset.title": "Reset password",
  "auth.reset.subtitle": "Enter your new password",
  "auth.reset.newPassword": "New password",
  "auth.reset.confirmPassword": "Confirm new password",
  "auth.reset.submitting": "Resetting...",
  "auth.reset.submit": "Reset password",
  "auth.reset.success": "Password reset",
  "auth.reset.successMessage": "Your password has been reset. Please sign in with your new password.",
  "auth.reset.goToLogin": "Go to sign in",
  "auth.reset.invalidLink": "Invalid link",
  "auth.reset.invalidLinkMessage": "The reset link is invalid or the token is missing. Please request a new reset.",
  "auth.reset.reapply": "Request again",
  "auth.reset.passwordMismatch": "Passwords do not match",
  "auth.reset.failedMessage": "Password reset failed. The link may have expired. Please request a new one.",
  "auth.reset.backToLogin": "Back to sign in",
  "auth.accept.title": "Activate your account",
  "auth.accept.subtitle": "Set a password to finish setting up your Fastcade account",
  "auth.accept.password": "Password",
  "auth.accept.confirmPassword": "Confirm password",
  "auth.accept.submit": "Activate account",
  "auth.accept.submitting": "Activating...",
  "auth.accept.success": "Account activated",
  "auth.accept.successMessage": "Your account is ready. Please sign in with your new password.",
  "auth.accept.goToLogin": "Go to sign in",
  "auth.accept.invalidLink": "Invalid invitation link",
  "auth.accept.invalidLinkMessage": "This link is missing its invitation token. Ask an administrator to send a new invitation.",
  "auth.accept.passwordMismatch": "The two passwords do not match",
  "auth.accept.failedMessage": "Could not activate the account. The invitation may have expired or already been used.",
  "auth.accept.backToLogin": "Back to sign in",
  "auth.verify.title": "Email verification",
  "auth.verify.verifying": "Verifying your email, please wait...",
  "auth.verify.success": "Email verified! You can now sign in.",
  "auth.verify.failed": "Verification failed or link expired. Please request a new verification email.",
  "auth.verify.invalidLink": "Invalid link: verification token missing",
  "auth.verify.goToLogin": "Go to sign in",
  "auth.verify.backToLogin": "Back to sign in",
  "auth.invite.title": "Create account",
  "auth.invite.subtitle": "Set up your credentials to complete registration.",
  "auth.invite.email": "Email",
  "auth.invite.name": "Name",
  "auth.invite.namePlaceholder": "Enter your name",
  "auth.invite.password": "Set password",
  "auth.invite.passwordPlaceholder": "Enter password",
  "auth.invite.confirmPassword": "Confirm password",
  "auth.invite.confirmPlaceholder": "Re-enter password",
  "auth.invite.submitting": "Submitting...",
  "auth.invite.submit": "Complete registration",
  "auth.invite.success": "Account created! Please sign in with your new password.",
  "auth.invite.successRedirect": "Account created. Redirecting to sign in...",
  "auth.invite.failed": "Registration failed",
  "auth.invite.emailRequired": "Email is required",
  "auth.invite.nameRequired": "Name is required",
  "auth.invite.passwordMin": "Password must be at least 8 characters",
  "auth.invite.passwordMismatch": "Passwords do not match",
  "auth.unauthorized.title": "Access denied",
  "auth.unauthorized.message": "You don't have permission to access this page.",
  "auth.unauthorized.goHome": "Go to home",
  "auth.unauthorized.switchAccount": "Switch account",
  "password.strength": "Password strength",
  "password.strong": "Strong",
  "password.weak": "Weak",
  "password.show": "Show password",
  "password.hide": "Hide password",
  "password.minLength": "Password must be at least 8 characters",
  "password.lowercase": "Password must contain a lowercase letter",
  "password.uppercase": "Password must contain an uppercase letter",
  "password.number": "Password must contain a number",
  "password.special": "Password must contain a special character (e.g. !@#$%^&*)",
  "privacy.title": "Privacy notice",
  "privacy.message": "We use cookies and analytics tools to improve user experience. These tools collect anonymous usage data and do not involve personal information.",
  "privacy.learnMore": "Learn more",
  "privacy.policyTitle": "Privacy policy",
  "privacy.policyDetails": "We only collect anonymous usage statistics\nNo personal information is collected\nData is used for product improvement\nGDPR compliant\nYou can withdraw consent at any time",
  "privacy.essential": "Essential only",
  "privacy.customize": "Customize",
  "privacy.acceptAll": "Accept all",
  "privacy.settingsTitle": "Data collection settings",
  "privacy.settingsMessage": "Would you like to allow us to collect anonymous usage data to improve the product?\n\nWe promise:\nOnly anonymous usage statistics\nNo personal information\nNo sharing with third parties\nGDPR compliant",
  "privacy.allowCollection": "Allow data collection",
  "privacy.decline": "Decline",
  "query.editCondition": "Edit filter condition",
  "query.done": "Done",
  "query.delete": "Delete",
  "theme.light": "Switch to light mode",
  "theme.dark": "Switch to dark mode",
  "resource.changeHistory": "Change History",
  "customer.label": "Customer",
  "customer.field.shopifyId": "Shopify ID",
  "customer.field.email": "Email",
  "customer.field.verifiedEmail": "Verified",
  "customer.field.firstName": "First Name",
  "customer.field.lastName": "Last Name",
  "customer.field.phone": "Phone",
  "customer.field.ordersCount": "Orders",
  "customer.field.lastOrderName": "Last Order",
  "customer.field.lastOrderId": "Last Order ID",
  "customer.field.totalSpent": "Total Spent",
  "customer.field.currency": "Currency",
  "customer.field.createdAt": "Customer Since",
  "customer.field.state": "State",
  "customer.field.acceptsMarketing": "Marketing",
  "customer.field.taxExempt": "Tax Exempt",
  "customer.field.addresses": "Address",
  "customer.field.tags": "Tags",
  "customer.field.note": "Note",
  "customer.field.source": "Source",
  "customer.field.receivedAt": "Received At",
  "customer.group.contact": "Contact Information",
  "customer.group.stats": "Overview",
  "customer.group.meta": "Metadata",
  "customer.enum.enabled": "Has account",
  "customer.enum.disabled": "No account",
  "customer.enum.invited": "Invited",
  "customer.enum.declined": "Declined invite",
  "customer.searchPlaceholder": "Search customers by name, email, or phone...",
  "customer.detail.fallbackName": "Customer",
  "customer.detail.subtitle": "Shopify ID: {{id}}",
  "customer.orders.sectionTitle": "Recent orders",
  "customer.orders.count": "({{count}} shown)",
  "customer.orders.countTruncated": "(showing first {{count}} — more exist)",
  "customer.orders.empty": "No orders yet.",
  "customer.orders.truncatedHint": "This customer has more than 50 orders. Open the Orders page and filter by customer ID to see the full history.",
  "order.label": "Order",
  "order.field.name": "Order",
  "order.field.email": "Customer",
  "order.field.totalPrice": "Total",
  "order.field.currency": "Currency",
  "order.field.financialStatus": "Payment",
  "order.field.fulfillmentStatus": "Fulfillment",
  "order.field.lineItems": "Items",
  "order.field.shippingLines": "Shipping Lines",
  "order.field.onfleetTaskCount": "Onfleet",
  "order.field.shippingAddress": "Shipping Address",
  "order.field.billingAddress": "Billing Address",
  "order.field.processedAt": "Date",
  "order.field.deliveryDate": "Delivery Date",
  "order.field.receivedAt": "Received At",
  "order.field.cancelledAt": "Cancelled At",
  "order.field.cancelReason": "Cancel Reason",
  "order.field.closedAt": "Closed At",
  "order.field.discountCodes": "Discount Codes",
  "order.field.taxLines": "Tax Lines",
  "order.field.note": "Note",
  "order.field.noteAttributes": "Note Attributes",
  "order.field.tags": "Tags",
  "order.field.gateway": "Gateway",
  "order.field.source": "Source",
  "order.field.shopifyId": "Shopify ID",
  "order.field.createdAt": "Created",
  "order.group.summary": "Summary",
  "order.group.items": "Items",
  "lineItem.title": "Product",
  "lineItem.quantity": "Qty",
  "lineItem.price": "Unit Price",
  "lineItem.subtotal": "Subtotal",
  "lineItem.empty": "No line items",
  "lineItem.rawData": "Raw data",
  "lineItem.jobQuantity": "This Job",
  "order.group.more": "More",
  "order.enum.paid": "Paid",
  "order.enum.pending": "Pending",
  "order.enum.refunded": "Refunded",
  "order.enum.authorized": "Authorized",
  "order.enum.partiallyPaid": "Partially paid",
  "order.enum.partiallyRefunded": "Partially refunded",
  "order.enum.voided": "Voided",
  "order.enum.fulfilled": "Fulfilled",
  "order.enum.partial": "Partial",
  "order.enum.unfulfilled": "Unfulfilled",
  "order.searchPlaceholder": "Search orders by number, email, or customer...",
  "order.detail.subtitle": "Order #{{number}}",
  "order.refetch.sectionTitle": "Re-fetch from Shopify",
  "order.refetch.sectionDescription": "Pull the latest order state from Shopify and re-apply it locally. Use when a webhook may have been missed.",
  "order.refetch.button": "Re-fetch from Shopify",
  "order.refetch.success.title": "Re-fetch complete",
  "order.refetch.success.applied": "Order refreshed from Shopify (updated {{updatedAt}}).",
  "order.refetch.success.stale": "Shopify has no newer state than what is already stored. Nothing to update.",
  "order.refetch.success.projectionOnlyHint": "Only the order projection was re-synced; driver tasks are not created or updated by this action.",
  "order.refetch.error.title": "Re-fetch failed",
  "order.refetch.error.notFound": "Shopify reports this order does not exist. It may have been deleted or the id is wrong.",
  "order.refetch.error.unknown": "Could not reach Shopify. Detail: {{detail}}",
  "order.trace.sectionTitle": "Trace",
  "order.trace.sectionDescription": "Chronological per-order data flow — webhooks ingressed, the order projection write, webhook failures, audited operator actions, delivery jobs (the split step), and Onfleet dispatch. Click each event to inspect the raw row.",
  "order.trace.loading": "Loading trace…",
  "order.trace.empty": "No trace events yet.",
  "order.trace.notFound": "Trace not available — order not found in the local mirror.",
  "order.trace.errorLoad": "Could not load trace. Detail: {{detail}}",
  "order.trace.summary": "Events: {{events}} · Trace ids: {{traces}}",
  "order.trace.cancelled": "Cancelled",
  "order.trace.payloadLabel": "Raw payload",
  "order.trace.payloadTruncated": "Payload truncated (over 64KB) — showing the leading bytes.",
  "order.trace.showDetails": "Show details",
  "order.trace.hideDetails": "Hide details",
  "order.trace.kind.webhookReceived": "Webhook",
  "order.trace.kind.orderProjected": "Order projected",
  "order.trace.kind.webhookFailure": "Webhook failure",
  "order.trace.kind.operatorAction": "Operator action",
  "order.trace.kind.fulfillmentJob": "Delivery job",
  "order.trace.kind.onfleetTask": "Driver task",
  "order.trace.kind.unknown": "Unknown event",
  "reviewQueue.pageTitle": "Operator Inbox",
  "reviewQueue.tab.pending": "Pending",
  "reviewQueue.tab.history": "History",
  "reviewQueue.group.main": "Overview",
  "reviewQueue.totalUnresolved": "Total unresolved items",
  "reviewQueue.refresh": "Refresh",
  "reviewQueue.loading": "Loading items…",
  "reviewQueue.errorLoad": "Could not load the operator inbox. Detail: {{detail}}",
  "reviewQueue.empty": "Inbox is clear — no unresolved items.",
  "reviewQueue.kind.post_cutoff_order_change": "Post-cutoff order change",
  "reviewQueue.kind.unknown_onfleet_task": "Unknown driver task",
  "reviewQueue.kind.webhook_failure_persistent": "Persistent webhook failure",
  "reviewQueue.kind.manual_refetch_needed": "Manual refetch needed",
  "reviewQueue.kind.post_dispatch_cancellation": "Post-dispatch cancellation",
  "reviewQueue.kind.dispatch_failed": "Dispatch failed",
  "reviewQueue.cause.shopify_cancellation_after_dispatch": "Post-dispatch cancellation",
  "reviewQueue.cause.order_refunded_after_dispatch": "Post-dispatch full refund",
  "reviewQueue.cause.quantity_changed_after_dispatch": "Post-dispatch quantity change",
  "reviewQueue.cause.address_changed_after_dispatch": "Post-dispatch address change",
  "reviewQueue.summary.post_cutoff_order_change": "Order {{orderId}} changed after cutoff — verify Onfleet contents",
  "reviewQueue.summary.post_dispatch_cancellation": "Order {{orderId}} — {{cause}}",
  "reviewQueue.summary.dispatch_failed": "Order {{orderId}} — dispatch failed ({{errorKind}})",
  "reviewQueue.summaryCause.shopify_cancellation_after_dispatch": "cancellation arrived after dispatch",
  "reviewQueue.summaryCause.quantity_changed_after_dispatch": "quantity changed after dispatch — Onfleet contents stale",
  "reviewQueue.summaryCause.address_changed_after_dispatch": "address changed after dispatch — driver heading to old address",
  "reviewQueue.errorKind.provider_rejected": "provider rejected the request",
  "reviewQueue.errorKind.provider_unreachable": "provider unreachable",
  "reviewQueue.errorKind.unexpected": "unexpected failure",
  "reviewQueue.col.kind": "Kind",
  "reviewQueue.col.summary": "Summary",
  "reviewQueue.col.createdAt": "Created",
  "reviewQueue.col.actions": "Actions",
  "reviewQueue.row.resolve": "Resolve",
  "reviewQueue.row.confirmResolve": "Confirm",
  "reviewQueue.row.notePlaceholder": "Resolution note (optional)",
  "reviewQueue.row.noteLabel": "Resolution note",
  "reviewQueue.row.traceLabel": "trace: {{traceId}}",
  "reviewQueue.detail.title": "Item detail",
  "reviewQueue.detail.kind": "Kind",
  "reviewQueue.detail.traceId": "Trace ID",
  "reviewQueue.detail.createdAt": "Created",
  "reviewQueue.detail.noPayload": "This row carries no detail payload.",
  "reviewQueue.detail.payload": "Detail payload",
  "reviewQueue.detail.handling": "Handling",
  "reviewQueue.detail.guidance": "What to do",
  "reviewQueue.detail.currentContents": "Current order contents",
  "reviewQueue.detail.currentContentsHint": "What the order says now — reconcile the driver task against this, not against the message.",
  "reviewQueue.detail.contentsUnavailable": "The order behind this message could not be loaded, so its current contents are not shown.",
  "reviewQueue.col.item": "Item",
  "reviewQueue.col.qty": "Qty",
  "reviewQueue.guidance.quantity_changed_after_dispatch": "The order was already dispatched, so the driver is carrying the OLD contents. Open the driver task in Onfleet and correct it against the current contents below; if it is too late to change what is delivered, contact the customer and pick the matching compensation below.",
  "reviewQueue.guidance.address_changed_after_dispatch": "The order was already dispatched and the driver is heading to the OLD address. Update the destination on the driver task in Onfleet now; if the driver has already arrived or delivered, contact the customer before choosing a disposition.",
  "reviewQueue.guidance.shopify_cancellation_after_dispatch": "The customer cancelled after the order was dispatched, so a delivery is in progress for an order that no longer exists. Cancel the driver task in Onfleet; if it cannot be stopped in time, decide the compensation below.",
  "reviewQueue.guidance.order_refunded_after_dispatch": "The order was refunded in full after it was dispatched. Cancel the driver task in Onfleet if the delivery has not happened yet, then close this with the disposition that matches what the customer actually received.",
  "reviewQueue.guidance.post_cutoff_order_change": "The order changed after the packing cutoff, so what the kitchen packed may no longer match it. Check the packed contents against the current contents below and update the driver task in Onfleet if they differ.",
  "reviewQueue.guidance.dispatch_failed": "Dispatch to Onfleet failed, so there is probably no driver task for this order at all. Check Onfleet: if the driver task was never created, retry the dispatch from the delivery job, or create the driver task by hand and record which you did below.",
  "reviewQueue.guidance.fallback": "This message has no handling guidance yet. Open the linked order and driver task, decide what the customer needs, and record it below.",
  "reviewQueue.detail.relatedEntities": "Related entities",
  "reviewQueue.detail.relatedOrder": "Order",
  "reviewQueue.detail.relatedJob": "Delivery job",
  "reviewQueue.detail.relatedOnfleetTask": "Driver task",
  "reviewQueue.row.resolutionLabel": "Resolution",
  "reviewQueue.row.resolutionPlaceholder": "Choose a resolution…",
  "reviewQueue.resolveOption.post_cutoff_order_change.no_change_needed": "No customer impact — close as informational",
  "reviewQueue.resolveOption.post_cutoff_order_change.contents_updated": "Updated Onfleet contents to match new order",
  "reviewQueue.resolveOption.post_cutoff_order_change.contacted_customer": "Contacted customer to confirm change",
  "reviewQueue.resolveOption.post_dispatch_cancellation.comp_full": "Comp full order (refund + apology)",
  "reviewQueue.resolveOption.post_dispatch_cancellation.comp_partial": "Comp affected items only",
  "reviewQueue.resolveOption.post_dispatch_cancellation.chase_customer": "Contact customer for guidance",
  "reviewQueue.resolveOption.post_dispatch_cancellation.no_action_needed": "No customer impact — close as informational",
  "reviewQueue.resolveOption.dispatch_failed.retried_ok": "Retried dispatch — driver task now created",
  "reviewQueue.resolveOption.dispatch_failed.dispatched_manually": "Created the driver task manually",
  "reviewQueue.resolveOption.dispatch_failed.no_action_needed": "No action needed — order not shipping",
  "reviewQueue.resolveOption.acknowledged_legacy": "Acknowledge legacy item",
  "reviewQueue.prevPage": "Previous page",
  "reviewQueue.nextPage": "Next page",
  "reviewQueue.paginationFooter": "Showing {{from}}–{{to}} of {{total}}",
  "reviewQueue.resolve.success.title": "Resolved",
  "reviewQueue.resolve.success.single": "Item moved out of the inbox.",
  "reviewQueue.resolve.error.title": "Could not resolve",
  "reviewQueue.resolve.error.alreadyResolved": "Another operator already resolved this item.",
  "reviewQueue.resolve.error.unknown": "Resolve failed. Detail: {{detail}}",
  "webhookFailures.pageTitle": "Webhook failures",
  "webhookFailures.totalUnresolved": "Total unresolved failures",
  "webhookFailures.loading": "Loading failures…",
  "webhookFailures.errorLoad": "Could not load webhook failures. Detail: {{detail}}",
  "webhookFailures.empty": "No unresolved webhook failures.",
  "webhookFailures.provider.shopify": "Shopify",
  "webhookFailures.provider.onfleet": "Onfleet",
  "webhookFailures.errorKind.signature_verify_failed": "Signature verify failed",
  "webhookFailures.errorKind.schema_parse_failed": "Schema parse failed",
  "webhookFailures.errorKind.d1_write_failed": "Local database write failed",
  "webhookFailures.errorKind.repo_write_failed": "Repo write failed",
  "webhookFailures.errorKind.use_case_threw": "Use case threw",
  "webhookFailures.errorKind.idempotency_replay_mismatch": "Idempotency replay mismatch",
  "webhookFailures.errorKind.secret_misconfigured": "Secret misconfigured",
  "webhookFailures.errorKind.topic_not_owned": "Topic not owned",
  "webhookFailures.errorKind.race_deleted_job": "Race: job deleted",
  "webhookFailures.col.provider": "Provider",
  "webhookFailures.col.topic": "Topic",
  "webhookFailures.col.errorKind": "Error kind",
  "webhookFailures.col.errorMessage": "Error message",
  "webhookFailures.col.receivedAt": "Received",
  "webhookFailures.col.createdAt": "Created",
  "webhookFailures.col.resolved": "Resolved",
  "webhookFailures.col.actions": "Actions",
  "webhookFailures.row.resolve": "Mark resolved",
  "webhookFailures.row.replay": "Replay",
  "webhookFailures.row.traceLabel": "trace: {{traceId}}",
  "webhookFailures.replay.title": "Replay",
  "webhookFailures.replay.errorTitle": "Replay failed",
  "webhookFailures.replay.outcome.resolved": "Replayed and resolved — the webhook reprocessed cleanly.",
  "webhookFailures.replay.outcome.duplicate": "Replayed — the event was already processed (duplicate); the failure is now closed.",
  "webhookFailures.replay.outcome.replayed": "Replayed through the live core; the failure is now closed.",
  "webhookFailures.replay.outcome.payloadUnavailable": "No stored payload backs this failure — it cannot be replayed.",
  "webhookFailures.replay.outcome.alreadyResolved": "Another operator already resolved this failure.",
  "webhookFailures.replay.outcome.stillBroken": "Replay ran but the payload contract is still broken.",
  "webhookFailures.replay.outcome.stillFailing": "Replay ran but the webhook still failed — retryable.",
  "webhookFailures.replay.outcome.notFound": "No failure with that id.",
  "webhookFailures.replay.outcome.unknown": "Replay failed. Detail: {{detail}}",
  "webhookFailures.selectAllOnPage": "Select all failures on this page",
  "webhookFailures.selectRow": "Select failure {{id}}",
  "webhookFailures.prevPage": "Previous page",
  "webhookFailures.nextPage": "Next page",
  "webhookFailures.paginationFooter": "Showing {{from}}–{{to}} of {{total}}",
  "webhookFailures.bulkResolve.selectedCount": "{{count}} selected",
  "webhookFailures.bulkResolve.submit": "Mark selected resolved",
  "webhookFailures.bulkResolve.clear": "Clear selection",
  "webhookFailures.bulkResolve.success.title": "Bulk resolve complete",
  "webhookFailures.bulkResolve.success.summary": "Resolved {{resolved}}; {{alreadyResolved}} already resolved; {{notFound}} not found.",
  "webhookFailures.bulkResolve.error.title": "Bulk resolve failed",
  "webhookFailures.bulkResolve.error.unknown": "Could not resolve selected failures. Detail: {{detail}}",
  "webhookFailures.resolve.success.title": "Resolved",
  "webhookFailures.resolve.success.single": "Failure moved out of the inbox.",
  "webhookFailures.resolve.error.title": "Could not resolve",
  "webhookFailures.resolve.error.alreadyResolved": "Another operator already resolved this failure.",
  "webhookFailures.resolve.error.unknown": "Resolve failed. Detail: {{detail}}",
  "error.order.notFound": "Order not found.",
  "order.recentTasks": "Recent Delivery Jobs",
  "order.noTasks": "No delivery jobs found",
  "order.noCustomer": "No customer",
  "order.customerDefaultAddress": "Customer default address",
  "order.customer.title": "Customer",
  "order.customer.viewProfile": "View customer profile",
  "order.customer.guest": "Guest checkout",
  "order.customer.email": "Email",
  "order.customer.phone": "Phone",
  "order.customer.ordersCount": "Orders",
  "order.customer.totalSpent": "Total spent",
  "order.customer.tags": "Tags",
  "order.customer.address": "Default address",
  "order.customer.note": "Note",
  "order.customer.unnamed": "Unnamed customer",
  "order.customer.noContact": "No contact information",
  "order.customer.loadError": "Failed to load customer details",
  "order.bag": "Bag: {{number}}",
  "order.moreItems": "+{{count}} more, see details",
  "order.onfleetCount": "Onfleet ({{count}})",
  "product.label": "Product",
  "product.field.shopifyId": "Shopify ID",
  "product.field.title": "Product Title",
  "product.field.bodyHtml": "Description",
  "product.field.productType": "Type",
  "product.field.status": "Status",
  "product.field.options": "Options",
  "product.field.variants": "Variants",
  "product.field.images": "Images",
  "product.field.vendor": "Vendor",
  "product.field.publishedAt": "Published",
  "product.field.createdAt": "Created",
  "product.field.handle": "Handle",
  "product.field.tags": "Tags",
  "product.field.seoTitle": "SEO Title",
  "product.field.seoDescription": "SEO Description",
  "product.field.source": "Source",
  "product.field.receivedAt": "Received At",
  "product.group.main": "Overview",
  "product.group.meta": "Metadata",
  "product.group.details": "Details",
  "product.enum.active": "Active",
  "product.enum.draft": "Draft",
  "product.enum.archived": "Archived",
  "product.enum.unlisted": "Unlisted",
  "product.detail.subtitle": "Shopify ID: {{id}}",
  "product.seo.preview": "SEO Preview",
  "product.seo.noDescription": "No description",
  "product.seo.metadata": "Metadata",
  "product.seo.created": "Created",
  "product.seo.updated": "Updated",
  "product.field.shippingDate": "Shipping Date",
  "product.shippingDateSource.metafield": "Metafield",
  "product.shippingDateSource.title": "Title",
  "product.shippingDateSource.manual": "Manual",
  "product.field.metafields": "Custom Metafields",
  "product.options.primary": "Primary Option",
  "product.options.values": "Values",
  "driver.label": "Driver",
  "driver.field.onfleetId": "Onfleet ID",
  "driver.field.name": "Name",
  "driver.field.displayName": "Driver Info",
  "driver.field.phone": "Phone",
  "driver.field.email": "Email",
  "driver.field.vehicle": "Vehicle",
  "driver.field.active": "Active",
  "driver.field.tasks": "Active Driver Tasks",
  "driver.field.isOnDuty": "On Duty",
  "driver.field.hasTasks": "Has Driver Tasks",
  "driver.field.lastActivity": "Last Activity",
  "driver.field.createdAt": "Created at",
  "driver.group.main": "Driver",
  "driver.group.tasks": "Driver Tasks",
  "driver.group.meta": "Metadata",
  "driver.searchPlaceholder": "Search drivers...",
  "driver.detail.subtitle": "Phone: {{phone}}",
  "driver.unknownDriver": "Unknown Driver",
  "driver.taskCount_one": "{{count}} driver task",
  "driver.taskCount_other": "{{count}} driver tasks",
  "driver.noTasks": "No driver tasks",
  "driver.onDuty": "On Duty",
  "driver.offDuty": "Off Duty",
  "driver.status": "Status: {{status}}",
  "job.label": "Delivery Job",
  "job.field.id": "Delivery Job ID",
  "job.field.name": "Name",
  "job.unnamed": "Unnamed",
  "job.field.orderId": "Order",
  "job.field.deliveryDate": "Delivery Date",
  "job.field.shippingDate": "Shipping Date",
  "job.field.status": "Status",
  "job.field.onfleetTaskId": "Driver Task",
  "job.field.onfleetTaskShortId": "Driver Task ID",
  "job.field.shopifyFulfillmentId": "Shopify Fulfillment",
  "job.field.customerName": "Customer Name",
  "job.field.customerPhone": "Phone",
  "job.field.deliveryAddress": "Delivery Address",
  "job.field.taskNote": "Driver Task Note",
  "job.field.orderNote": "Customer Note",
  "job.field.operatorNote": "Operator Note",
  "job.field.originalAddress": "Original Address",
  "job.field.attempt": "Attempts",
  "job.field.lastError": "Last Error",
  "job.field.lineItemsJson": "Order Items (qty in this job)",
  "job.field.dispatchSnapshotJson": "Dispatch Snapshot",
  "job.field.completionIdempotencyKey": "Idempotency Key",
  "job.field.batchSignature": "Batch signature",
  "job.field.createdAt": "Created",
  "job.field.updatedAt": "Updated",
  "job.group.main": "Delivery Job",
  "job.group.customer": "Customer",
  "job.group.data": "Items",
  "job.section.basic": "Basic Info",
  "job.section.driver": "Driver & Shopify",
  "job.section.recipient": "Recipient",
  "job.section.notes": "Notes",
  "job.section.record": "Record Info",
  "address.opensMaps": "(opens in Google Maps)",
  "address.copy": "Copy address",
  "address.copied": "Address copied",
  "job.progress.inWindow": "Within the delivery window {{start}}–{{end}}",
  "job.progress.ahead_one": "{{count}} job ahead",
  "job.progress.ahead_other": "{{count}} jobs ahead",
  "job.progress.active": "Delivering this one now",
  "job.progress.lateBy": "{{minutes}} min after {{end}}",
  "job.progress.delivered": "Delivered",
  "job.progress.deliveredAt": "Delivered {{time}}",
  "job.progress.deliveredBy": "Delivered by {{name}}",
  "job.progress.notYet": "Delivery date {{date}}. The estimated arrival appears once the driver sets out.",
  "job.progress.unavailable": "The delivery platform has not returned an estimated time yet. Driver: {{name}}",
  "job.progress.closed": "This job is not out for delivery, so it has no estimated arrival time.",
  "job.enum.planned": "Planned",
  "job.enum.dispatched": "Dispatched",
  "job.enum.in_progress": "In Progress",
  "job.enum.completed": "Completed",
  "job.enum.cancelled": "Cancelled",
  "job.enum.exception": "Exception",
  "job.searchPlaceholder": "Search by order number, customer name, phone, driver task ID, item, or note…",
  "job.preset.today": "Today",
  "job.preset.tomorrow": "Tomorrow",
  "job.preset.pastDate": "Past date",
  "job.preset.pastDateCount_one": ", {{count}} past-date delivery job",
  "job.preset.pastDateCount_other": ", {{count}} past-date delivery jobs",
  "job.today.title": "Today's deliveries · {{day}}",
  "job.today.progressLabel": "Today's delivery progress",
  "job.today.unavailable": "Today's counts are unavailable",
  "job.bulk.schedule.label": "Dispatch",
  "job.bulk.schedule.confirm.title_one": "Dispatch {{count}} selected delivery job now?",
  "job.bulk.schedule.confirm.title_other": "Dispatch {{count}} selected delivery jobs now?",
  "job.bulk.schedule.confirm.description": "Create a driver task for each selected to-dispatch delivery job, one by one — the same command as the detail page's Dispatch Now.",
  "job.bulk.schedule.result": "{{dispatched}} dispatched, {{failed}} failed",
  "job.bulk.schedule.disabledReason": "Only to-dispatch delivery jobs can be dispatched — deselect rows in other states.",
  "job.bulk.cancel.label": "Cancel",
  "job.bulk.cancel.confirm.title_one": "Cancel {{count}} selected delivery job?",
  "job.bulk.cancel.confirm.title_other": "Cancel {{count}} selected delivery jobs?",
  "job.bulk.cancel.confirm.description": "Planned delivery jobs are cancelled directly. For dispatched delivery jobs, the driver task on the delivery platform is deleted first, then the delivery job is cancelled; if the driver has already accepted it, that delivery job is not cancelled and must be handled manually on the delivery platform. This cannot be undone.",
  "job.bulk.cancel.confirm.keep": "Keep delivery jobs",
  "job.bulk.cancel.disabledReason": "Only planned or dispatched delivery jobs can be cancelled — deselect rows in other states.",
  "job.bulk.cancel.result": "{{cancelled}} cancelled, {{assigned}} not cancelled (driver accepted), {{failed}} failed",
  "job.detail.title": "Delivery job {{label}}",
  "job.searchHit.otherDate": "Matched via items for {{dates}}",
  "job.searchHit.otherDateHint": "This delivery job matched your search through a line item that ships on another delivery date of the same order.",
  "job.orderLabel": "{{name}} · {{date}}",
  "job.detail.subtitle": "{{status}} — {{date}}",
  "job.detail.noDate": "No date",
  "job.actions.more": "More actions",
  "job.actions.scheduleNow": "Dispatch now",
  "job.actions.reschedule": "Reschedule",
  "job.actions.cancel": "Cancel delivery job",
  "job.actions.refetch": "Refetch",
  "job.actions.cancelDispatched": "Cancel dispatch",
  "job.actions.success": "Action completed",
  "job.actions.note.edit": "Edit note",
  "job.actions.note.dialogTitle": "Operator note",
  "job.actions.note.dialogSubtitle": "Save delivery instructions for this delivery job. They are sent to the delivery platform only when the driver task is created.",
  "job.actions.note.label": "Note",
  "job.actions.note.placeholder": "Add dispatch instructions",
  "job.actions.note.save": "Save note",
  "job.actions.note.success": "Operator note saved",
  "job.actions.error.title": "Action failed",
  "job.actions.error.generic": "The action could not be completed. Please try again.",
  "job.actions.error.onfleetTaskAssigned": "The driver has already accepted it, so it can't be cancelled automatically. Please handle it manually on the delivery platform.",
  "job.actions.confirm.schedule.title": "Dispatch this delivery job now?",
  "job.actions.confirm.schedule.message": "A driver task will be created immediately for this delivery job.",
  "job.actions.confirm.cancel.title": "Cancel this delivery job?",
  "job.actions.confirm.cancel.message": "This to-dispatch delivery job will be cancelled. This cannot be undone.",
  "job.actions.confirm.cancelDispatched.title": "Cancel dispatch?",
  "job.actions.confirm.cancelDispatched.message": "The driver task will be torn down and the delivery job returned from dispatched. This cannot be undone.",
  "job.actions.reschedule.dialogTitle": "Reschedule delivery job",
  "job.actions.reschedule.dialogSubtitle": "Move this to-dispatch delivery job to a new delivery date.",
  "job.actions.reschedule.dateLabel": "New delivery date",
  "job.actions.reschedule.dateRequired": "Select a delivery date.",
  "job.actions.reschedule.submit": "Reschedule",
  "job.unresolvedOrder": "Unresolved order",
  "job.unresolvedOrderTooltip": "Order name could not be resolved",
  "webhook.title": "Webhook Events",
  "webhook.group.main": "Overview",
  "webhook.searchPlaceholder": "Filter webhook events by topic, provider, status, date…",
  "webhook.field.id": "ID",
  "webhook.field.provider": "Provider",
  "webhook.field.tenantId": "Tenant",
  "webhook.field.traceId": "Trace",
  "webhook.field.apiVersion": "API Version",
  "webhook.field.providerEventId": "Provider Event ID",
  "webhook.field.providerEmittedAt": "Emitted At",
  "webhook.field.lastAttemptAt": "Last Attempt At",
  "webhook.field.completedAt": "Completed At",
  "webhook.field.source": "Source",
  "webhook.field.topic": "Topic",
  "webhook.field.eventKey": "Event Key",
  "webhook.field.status": "Status",
  "webhook.field.error": "Error",
  "webhook.field.receivedAt": "Received At",
  "webhook.field.processedAt": "Processed At",
  "webhook.field.payload": "Payload",
  "webhook.field.headers": "Headers",
  "webhook.field.payloadHash": "Payload Hash",
  "webhook.enum.shopify": "Shopify",
  "webhook.enum.onfleet": "Onfleet",
  "webhook.enum.received": "Received",
  "webhook.enum.completed": "Completed",
  "webhook.enum.unknownProvider": "Unknown provider: {{provider}}",
  "webhook.enum.pending": "Pending",
  "webhook.enum.success": "Success",
  "webhook.enum.failed": "Failed",
  "webhook.enum.retrying": "Retrying",
  "webhook.group.timing": "Timing",
  "webhook.group.content": "Content",
  "webhook.payload.title": "Raw payload",
  "webhook.payload.loading": "Loading payload…",
  "webhook.payload.loadError": "Failed to load payload: {{detail}}",
  "webhook.payload.thinned": "The raw payload was cleared by retention and is no longer available.",
  "webhook.recovery.title": "Recovery",
  "webhook.recovery.description": "Re-drive this delivery through the live ingestion core. Use it when the event is still Received long after it arrived — a database overload can leave a delivery stranded with no failure record behind it.",
  "webhook.recovery.replay": "Replay",
  "webhook.recovery.replaying": "Replaying…",
  "webhook.recovery.notStuck": "Only an event still in Received can be replayed here. A failed event is replayed from the webhook failures inbox.",
  "webhook.recovery.replayed": "Replayed through the live core (outcome: {{outcome}}).",
  "webhook.recovery.replayError": "Replay failed: {{detail}}",
  "profile.pageTitle": "Profile",
  "profile.subtitle": "Your account and how you sign in.",
  "profile.accountDetails": "Account Details",
  "profile.accountDetailsDesc": "View your account information",
  "profile.accountId": "Account ID",
  "profile.role": "Role",
  "profile.emailVerified": "Email Verified",
  "profile.verified": "Verified",
  "profile.unverified": "Unverified",
  "profile.lastUpdated": "Last Updated",
  "profile.editProfile": "Edit Profile",
  "profile.editProfileDesc": "Update your personal information",
  "profile.displayName": "Display Name",
  "profile.displayNamePlaceholder": "Enter your name",
  "profile.emailLabel": "Email",
  "profile.emailManaged": "Email is managed by the administrator.",
  "profile.saveChanges": "Save Changes",
  "profile.saving": "Saving...",
  "profile.updateSuccess": "Profile updated successfully",
  "profile.updateFailed": "Failed to update profile",
  "profile.loadingProfile": "Loading profile...",
  "profile.security": "Security",
  "profile.securityDesc": "Manage your password and security settings",
  "profile.passwordChanged": "Password changed successfully. All other sessions have been logged out.",
  "profile.passwordChangeFailed": "Failed to change password",
  "user.unknown": "Unknown User",
  "users.title": "User Management",
  "users.subtitle": "Manage team members, roles, and permissions.",
  "users.inviteUser": "Invite User",
  "users.inviteModalTitle": "Invite User",
  "users.inviteModalDesc": "Send an invitation email to join the system.",
  "users.emailLabel": "Email",
  "users.emailPlaceholder": "user@example.com",
  "users.nameLabel": "Name (optional)",
  "users.namePlaceholder": "John Doe",
  "users.roleLabel": "Role",
  "users.sending": "Sending...",
  "users.sendInvite": "Send Invite",
  "users.inviteFailed": "Failed to invite user",
  "users.invitationSent": "Invitation sent",
  "users.columnEmail": "Email",
  "users.columnName": "Name",
  "users.columnRole": "Role",
  "users.columnStatus": "Status",
  "users.statusActive": "Active",
  "users.noUsers": "No users found",
  "users.revokeInvitationFailed": "Could not revoke the invitation",
  "users.revokeInvitation": "Revoke Invitation",
  "users.revokeInvitationConfirm": "This deletes the invited account and its pending invitation. The link already sent stops working, and it will free the email address so it can be invited again. This cannot be undone.",
  "users.invitationRevoked": "Invitation revoked. The email address is free again.",
  "users.resendInvitation": "Resend Invitation",
  "users.invitationResent": "A new invitation has been sent. The previous link no longer works.",
  "users.invitation.title": "Invitation awaiting acceptance",
  "users.invitation.sentAt": "Sent",
  "users.invitation.expiresAt": "Expires",
  "users.invitation.expired": "Expired",
  "users.changeRole": "Change Role",
  "users.changeRoleTooltip": "Change role",
  "users.roleUpdateFailed": "Failed to update role",
  "users.permissionsUpdateFailed": "Failed to update permissions",
  "users.error.self_role_change_forbidden": "You cannot change your own role.",
  "users.error.last_admin_protected": "Cannot remove the last admin.",
  "users.error.no_updatable_fields": "No updatable fields were provided.",
  "users.error.filter_conflict": "Cannot combine the role filter with a generic field filter — choose one.",
  "users.error.search_missing_value": "A search value is required when a search field or operator is set.",
  "users.error.filter_missing_value": "A filter value is required when a filter field or operator is set.",
  "users.error.pagination_conflict": "Use either page or offset for pagination, not both.",
  "users.permRoleLabel": "Role",
  "users.permResourceCol": "Resource",
  "users.dismiss": "Dismiss",
  "users.adminFullAccess": "Admin role has full access to all permissions. Individual permissions cannot be edited.",
  "users.detail.backToList": "Back to users",
  "users.detail.profileTitle": "Profile",
  "users.detail.emailHint": "Email is managed by the identity provider and cannot be changed here.",
  "users.detail.statusLabel": "Status",
  "users.detail.roleSectionTitle": "Role",
  "users.detail.saveRole": "Save role",
  "users.detail.roleUpdated": "Role updated",
  "users.detail.permissionsTitle": "Effective permissions",
  "users.detail.permissionsEmpty": "No effective permissions",
  "users.detail.notFoundTitle": "User not found",
  "users.detail.notFoundDesc": "The user you are looking for does not exist or has been removed.",
  "users.detail.loadFailed": "Failed to load user",
  "users.detail.lastLogin": "Last login",
  "users.detail.lastLoginNever": "Never",
  "users.detail.createdAt": "Created",
  "perm.customized": "Customized",
  "perm.resetToRole": "Reset to defaults",
  "perm.fetchFailed": "Failed to load permissions, showing role defaults",
  "dispatch.title": "Logistics",
  "dispatch.header.flowLabel": "Flow: ",
  "dispatch.header.flowBatch.shipping_date": "By delivery date",
  "dispatch.header.flowStates_one": "{{count}} state",
  "dispatch.header.flowStates_other": "{{count}} states",
  "dispatch.header.flowSettings": "Settings",
  "dispatch.header.range": "{{from}} – {{to}}",
  "dispatch.header.pickDate": "Pick a delivery date",
  "dispatch.view.label": "View",
  "dispatch.view.board": "Batch board",
  "dispatch.view.list": "List",
  "dispatch.view.map": "Map",
  "dispatch.overview.runExplainer": "Running dispatch creates Onfleet driver tasks for dispatchable delivery jobs; anomalous ones must be resolved first.",
  "dispatch.consolidate.label": "Consolidate by address",
  "dispatch.dispatching": "Dispatching...",
  "dispatch.dispatchingProgress": "Dispatching... ({{dispatched}} so far)",
  "dispatch.runCard.gate": "{{batch}} · Dispatch {{from}}–{{to}}",
  "dispatch.runCard.gateOtherDay": "{{batch}} · Dispatch {{from}}–{{to}} that day",
  "dispatch.runCard.gateCutoffOnly": "{{batch}} · Dispatch cutoff {{at}}",
  "dispatch.runCard.gateCutoffOnlyOtherDay": "{{batch}} · Dispatch cutoff {{at}} that day",
  "dispatch.runCard.tasksUnit_one": "driver task",
  "dispatch.runCard.tasksUnit_other": "driver tasks",
  "dispatch.runCard.fromJobs_one": "from {{count}} delivery job",
  "dispatch.runCard.fromJobs_other": "from {{count}} delivery jobs",
  "dispatch.runCard.mergeNow_one": "{{count}} same-address stop can merge now",
  "dispatch.runCard.mergeNow_other": "{{count}} same-address stops can merge now",
  "dispatch.runCard.mergeOff": "One driver task per delivery job",
  "dispatch.runCard.timelinePackaging": "{{at}} printout cutoff",
  "dispatch.runCard.runBeforeCutoff": "Dispatch now (best after {{at}})",
  "dispatch.runCard.run": "Dispatch",
  "dispatch.runCard.runEarly": "Dispatch early",
  "dispatch.runCard.note": "Same-address orders that arrive after a run go out as their own new driver task on the next run; they never join a driver task already sent. Run once after the printout cutoff to merge the most addresses.",
  "dispatch.runCard.confirmTitle_one": "Dispatch {{count}} delivery job for {{batch}}",
  "dispatch.runCard.confirmTitle_other": "Dispatch {{count}} delivery jobs for {{batch}}",
  "dispatch.runCard.confirmJobs": "Delivery jobs",
  "dispatch.runCard.confirmTasks": "Driver tasks",
  "dispatch.runCard.confirmAnomalies": "Pre-check anomalies",
  "dispatch.runCard.confirmNoteAnomalies_one": "{{count}} pre-check anomaly is still open: a run now stops part-way through this batch. Cancel that delivery job on the left first.",
  "dispatch.runCard.confirmNoteAnomalies_other": "{{count}} pre-check anomalies are still open: a run now stops part-way through this batch. Cancel those delivery jobs on the left first.",
  "dispatch.runCard.confirmNote": "This creates driver tasks in Onfleet. Same-address orders that arrive later go out as their own new driver task on the next run; they never join this run's driver tasks.",
  "dispatch.runCard.confirmRun": "Dispatch",
  "dispatch.moreChecks.title": "More checks",
  "dispatch.runProgressCount": "Processed {{processed}} / total {{total}} (remaining {{remaining}})",
  "dispatch.dayJobs": "Day's delivery jobs",
  "dispatch.dayJobsEmpty": "No delivery jobs for this date",
  "dispatch.eta.title": "Route ETAs",
  "dispatch.eta.asOf": "As of {{time}}",
  "dispatch.eta.empty": "No active routes right now.",
  "dispatch.eta.error": "Couldn't load route ETAs.",
  "dispatch.eta.unknownOrder": "Unlabeled stop",
  "dispatch.eta.state.assigned": "Assigned",
  "dispatch.eta.state.active": "Active",
  "dispatch.eta.state.completed": "Completed",
  "dispatch.eta.todayOnly": "Live data — today only",
  "dispatch.eta.loading": "Loading routes…",
  "dispatch.eta.pendingCount": "{{count}} pending",
  "dispatch.eta.completedCount": "{{count}} completed",
  "dispatch.eta.totalCount": "{{count}} total",
  "dispatch.eta.progress": "{{completed}}/{{total}}",
  "dispatch.eta.nextStopLabel": "Next",
  "dispatch.eta.allDone": "Wrapped up",
  "dispatch.eta.latestEta": "Last ETA {{time}}",
  "dispatch.eta.noEta": "No ETA",
  "dispatch.reconcileAll.running": "Reconciling…",
  "dispatch.reconcile.idle": "Not reconciled yet — run \"Check now\" above.",
  "dispatch.delivered.kpi.delivered": "Delivered",
  "dispatch.delivered.kpi.ofTotal": "/ {{total}}",
  "dispatch.delivered.kpi.late": "After {{at}}",
  "dispatch.delivered.kpi.lateHint": "By completion time",
  "dispatch.delivered.kpi.writtenBack": "Shopify fulfillment written back",
  "dispatch.delivered.kpi.writtenBackHint": "Counted from the Shopify fulfillment on each delivery job; jobs marked delivered by a manual refresh are not written back",
  "dispatch.delivered.reconcile.title": "Reconcile",
  "dispatch.delivered.reconcile.runFirst": "Check now",
  "dispatch.delivered.reconcile.runAgain": "Check again",
  "dispatch.delivered.reconcile.shopifySide": "Shopify side",
  "dispatch.delivered.reconcile.onfleetSide": "Onfleet side",
  "dispatch.delivered.reconcile.shopifyWhy": "Demand and stock, against Shopify",
  "dispatch.delivered.reconcile.onfleetWhy": "Delivery jobs, against Onfleet driver tasks",
  "dispatch.delivered.reconcile.match": "Match",
  "dispatch.delivered.note.title": "This batch",
  "dispatch.delivered.note.body": "Nothing to do after delivery. Failed deliveries show up in the Exception / cancelled column.",
  "dispatch.reconcile.diffLabel_one": "diff",
  "dispatch.reconcile.diffLabel_other": "diffs",
  "dispatch.reconcileCheck.notRun": "Not run",
  "dispatch.reconcileCheck.alertCount": "{{count}} {{label}}",
  "dispatch.reconcile.running": "Running reconcile check…",
  "dispatch.reconcile.onfleetNotReady_one": "Onfleet does not have any driver tasks for {{date}} yet ({{count}} local delivery job is waiting to be reconciled). Onfleet usually creates them in a batch early on the delivery date. Please run the reconcile check again later.",
  "dispatch.reconcile.onfleetNotReady_other": "Onfleet does not have any driver tasks for {{date}} yet ({{count}} local delivery jobs are waiting to be reconciled). Onfleet usually creates them in a batch early on the delivery date. Please run the reconcile check again later.",
  "dispatch.reconcile.warning": "Local delivery jobs are missing {{count}} for {{date}}.",
  "dispatch.reconcile.realDiffSummary_one": "{{count}} date-scoped difference needs attention for {{date}}.",
  "dispatch.reconcile.realDiffSummary_other": "{{count}} date-scoped differences need attention for {{date}}.",
  "dispatch.reconcile.realDiffOrders": "Orders",
  "dispatch.reconcile.more": " +{{count}} more",
  "dispatch.reconcile.backfillGuidance": "Before dispatching, follow the materialize-backfill runbook action (POST /api/fulfillment-jobs/materialize-backfill), then run this check again.",
  "dispatch.reconcile.passed": "Reconcile passed",
  "dispatch.reconcile.totals": "Ours: {{ours}} · Onfleet: {{gas}}",
  "dispatch.reconcile.secondary": "Missing from Onfleet: {{missingGas}} · Delivery job counts diverged: {{diverged}}",
  "dispatch.reconcile.cancelledOurs": "Cancelled on our side: {{count}} (refund or cancellation after Onfleet had built the driver task; cancel the leftover driver task on the GAS side)",
  "dispatch.reconcile.outOfBand": "Out-of-band driver tasks in Onfleet: {{count}} (no matching Shopify order; known non-defect)",
  "dispatch.reconcile.error": "Reconcile check failed: {{message}}",
  "dispatch.truthReconcile.running": "Verifying…",
  "dispatch.truthReconcile.idle": "Verify each dispatch number against Shopify (the source of truth) for the selected date. Read-only — nothing is written back.",
  "dispatch.truthReconcile.error": "Truth check failed: {{message}}",
  "dispatch.truthReconcile.empty": "Nothing to reconcile for this date.",
  "dispatch.truthReconcile.emptyValue": "—",
  "dispatch.truthReconcile.summary": "Drift: {{drift}} · Maybe skew: {{maybeSkew}} · Unknown: {{unknown}}",
  "dispatch.truthReconcile.asOf": "Shopify as of {{shopifyAsOf}} · local as of {{d1AsOf}}",
  "dispatch.truthReconcile.asOfShort": "as of {{at}}",
  "dispatch.truthReconcile.coverageIncomplete": "Coverage incomplete — some records could not be compared; treat counts as partial.",
  "dispatch.truthReconcile.oursLabel": "Ours (local records)",
  "dispatch.truthReconcile.truthLabel": "Truth (Shopify)",
  "dispatch.truthReconcile.method": "Method",
  "dispatch.truthReconcile.action": "Suggested action",
  "dispatch.truthReconcile.evidence.show": "Show evidence",
  "dispatch.truthReconcile.evidence.hide": "Hide evidence",
  "dispatch.truthReconcile.evidence.d1Rows": "Local rows",
  "dispatch.truthReconcile.evidence.shopifyRaw": "Shopify raw",
  "dispatch.truthReconcile.verdict.match": "Match",
  "dispatch.truthReconcile.verdict.drift": "Drift",
  "dispatch.truthReconcile.verdict.maybe_skew": "Maybe skew",
  "dispatch.truthReconcile.verdict.unknown": "Unknown",
  "dispatch.truthReconcile.tile.aria": "{{label}}: {{count}}",
  "dispatch.truthReconcile.allClear": "All dispatch numbers match Shopify — no drift.",
  "dispatch.truthReconcile.noneInView": "No items in this view.",
  "dispatch.salesBridge.title": "Delivery count check",
  "dispatch.salesBridge.description": "Check items ordered, refunded, and to deliver on {{date}}.",
  "dispatch.salesBridge.loading": "Loading…",
  "dispatch.salesBridge.error": "Failed to load. Please refresh.",
  "dispatch.salesBridge.empty": "No orders and no delivery jobs on this date.",
  "dispatch.salesBridge.productsTitle": "Items ordered per product",
  "dispatch.salesBridge.productsCount_one": "{{count}} product",
  "dispatch.salesBridge.productsCount_other": "{{count}} products",
  "dispatch.salesBridge.productsSoldOut": "{{count}} sold out",
  "dispatch.salesBridge.productCounts": "Ordered units: {{units}} · Orders: {{orders}}",
  "dispatch.salesBridge.multiQty_one": "{{count}} order with multiple items",
  "dispatch.salesBridge.multiQty_other": "{{count}} orders with multiple items",
  "dispatch.salesBridge.exceptionsTitle": "Refunded / cancelled — no delivery needed",
  "dispatch.salesBridge.exceptionUnits_one": "{{count}} item not delivered",
  "dispatch.salesBridge.exceptionUnits_other": "{{count}} items not delivered",
  "dispatch.salesBridge.removedRefundInfo": "Refunded and restocked — not counted in items ordered",
  "dispatch.salesBridge.missingJobsTitle": "Orders with no delivery job yet",
  "dispatch.salesBridge.missingJobsEmpty": "Every order has a delivery job",
  "dispatch.salesBridge.exceptionsEmpty": "No refunded or cancelled orders",
  "dispatch.salesBridge.unpaidTitle": "Orders that have not been paid",
  "dispatch.salesBridge.unpaidEmpty": "Every order is paid",
  "dispatch.salesBridge.alreadyPaid": "Shopify paid · local lagging",
  "dispatch.salesBridge.alreadyPaidHint_one": "{{count}} of these is already paid on Shopify (local snapshot lagging) — run Verify truth to confirm.",
  "dispatch.salesBridge.alreadyPaidHint_other": "{{count}} of these are already paid on Shopify (local snapshot lagging) — run Verify truth to confirm.",
  "dispatch.salesBridge.multiQtyDetailTitle": "Multiple items in one order — verify when packing",
  "dispatch.salesBridge.multiQtyDetailEmpty": "No orders with multiple items",
  "dispatch.salesBridge.multiQtyDetailRow": "{{order_name}} · {{product_name}} ×{{quantity}}",
  "dispatch.salesBridge.zeroUnitTitle": "Orders with a delivery job but 0 units to deliver on this date (excluded from to-deliver counts)",
  "dispatch.salesBridge.zeroUnitEmpty": "No zero-unit orders",
  "dispatch.salesBridge.zeroUnitJobStatuses": "Delivery job status: {{statuses}}",
  "dispatch.salesBridge.zeroUnitHint": "Common causes: refunded after delivery, or line items removed/moved by a refund.",
  "dispatch.salesBridge.jobStatusSeparator": ", ",
  "dispatch.salesBridge.passed": "Passed",
  "dispatch.salesBridge.needsConfirm": "{{count}} to confirm",
  "dispatch.salesBridge.allPassed": "All checks passed — ready to plan routes",
  "dispatch.salesBridge.parseFailuresTitle_one": "{{count}} order could not be read",
  "dispatch.salesBridge.parseFailuresTitle_other": "{{count}} orders could not be read",
  "dispatch.salesBridge.parseFailure.kind.malformed_json": "Malformed line-item data",
  "dispatch.salesBridge.parseFailure.kind.schema_invalid": "Invalid line-item structure",
  "dispatch.salesBridge.parseFailure.kind.invalid_created_at": "Invalid creation date",
  "dispatch.salesBridge.parseFailure.kind.missing_order": "Order record missing",
  "dispatch.salesBridge.parseFailure.kind.unknown": "Unknown parsing error",
  "dispatch.salesBridge.inventoryAvailable": "Local snapshot: {{count}} sellable",
  "dispatch.salesBridge.shopifyInventoryAvailable": "Shopify live: {{count}} sellable",
  "dispatch.salesBridge.shopifyInventoryUntracked": "Shopify live: inventory untracked",
  "dispatch.salesBridge.shopifyAsOf": "Shopify menu and inventory as of {{at}}",
  "dispatch.salesBridge.shopifyUnavailable": "Shopify menu and inventory unavailable: {{reason}}",
  "dispatch.salesBridge.anomaly.menuOnly": "Menu only · 0 local orders",
  "dispatch.salesBridge.anomaly.ordersOnly": "Orders only · missing from Shopify menu",
  "dispatch.salesBridge.anomaly.inactiveUpcoming": "Upcoming product is not active",
  "dispatch.salesBridge.anomaly.activeStale": "Past product is still active",
  "dispatch.salesBridge.refetchShopify": "Refresh Shopify data",
  "dispatch.salesBridge.refetching": "Refreshing Shopify data…",
  "dispatch.salesBridge.refetchApplied": "Shopify data refreshed",
  "dispatch.salesBridge.refetchNoChange": "Shopify data is already current",
  "dispatch.salesBridge.refetchError": "Failed to refresh Shopify data",
  "dispatch.salesBridge.reason.pending": "Pending payment",
  "dispatch.salesBridge.reason.authorized": "Authorized",
  "dispatch.salesBridge.reason.expired": "Expired",
  "dispatch.salesBridge.reason.partiallyPaid": "Partially paid",
  "dispatch.salesBridge.reason.paid": "Paid",
  "dispatch.salesBridge.reason.partiallyRefunded": "Partially refunded",
  "dispatch.salesBridge.reason.refunded": "Refunded",
  "dispatch.salesBridge.reason.voided": "Voided",
  "dispatch.salesBridge.reason.unknown": "Unknown financial status",
  "dispatch.funnel.title": "Today's dispatch picture",
  "dispatch.funnel.demand.label": "Demand",
  "dispatch.funnel.demand.summary": "Orders: {{orders}} · Units: {{units}}",
  "dispatch.funnel.demand.sameProductNote_one": "{{count}} same-product multiple (≥2 of one product)",
  "dispatch.funnel.demand.sameProductNote_other": "{{count}} same-product multiples (≥2 of one product)",
  "dispatch.funnel.demand.excludedNote": "Ordered today, not delivered (refund/cancel) — Orders: {{orders}} · Units: {{units}}",
  "dispatch.funnel.demand.source": "Source: order line items · per-item shipping date",
  "dispatch.funnel.jobs.label": "Jobs",
  "dispatch.funnel.jobs.ok_one": "{{count}} delivery job · gap 0",
  "dispatch.funnel.jobs.ok_other": "{{count}} delivery jobs · gap 0",
  "dispatch.funnel.jobs.gap_one": "{{count}} delivery job · gap {{gap}}",
  "dispatch.funnel.jobs.gap_other": "{{count}} delivery jobs · gap {{gap}}",
  "dispatch.funnel.jobs.source": "Source: order-side probe vs delivery jobs (independent check)",
  "dispatch.funnel.jobs.drilldownTitle": "Orders without a delivery job",
  "dispatch.funnel.dispatch.label": "Dispatch",
  "dispatch.funnel.dispatch.summary": "{{dispatched}} sent / {{undispatched}} pending",
  "dispatch.funnel.dispatch.beforeCutoff": "Not sent yet today (before {{at}} dispatch cutoff) — normal",
  "dispatch.funnel.dispatch.afterCutoff_one": "Past {{at}} cutoff — {{count}} delivery job still unsent",
  "dispatch.funnel.dispatch.afterCutoff_other": "Past {{at}} cutoff — {{count}} delivery jobs still unsent",
  "dispatch.funnel.dispatch.done": "All delivery jobs sent",
  "dispatch.funnel.dispatch.source": "Source: delivery jobs · Onfleet driver task link · manual dispatch run",
  "dispatch.funnel.dispatch.drilldownTitle": "Delivery jobs not yet sent to Onfleet",
  "dispatch.funnel.coordinates.label": "Coordinates",
  "dispatch.funnel.coordinates.summary": "{{ready}} ready / {{pending}} pending",
  "dispatch.funnel.coordinates.pendingNote": "Pending orders get coordinates automatically after dispatch — not an error",
  "dispatch.funnel.coordinates.alert_one": "{{count}} needs attention (dispatched but unresolved, or dangling)",
  "dispatch.funnel.coordinates.alert_other": "{{count}} need attention (dispatched but unresolved, or dangling)",
  "dispatch.funnel.coordinates.source": "Source: route-planning stops · geocode cache (Shopify/Onfleet coordinates)",
  "dispatch.funnel.coordinates.drilldownTitle": "Coordinate status detail",
  "dispatch.funnel.coordinates.orderMissing": "(order missing)",
  "dispatch.openReviewItems": "Open Review Items",
  "dispatch.critical": "{{count}} critical",
  "dispatch.error": "{{count}} error",
  "dispatch.error.paid_sweep_not_run_today": "Paid-sweep hasn't completed today yet. Cron sequence is 05:00 PT dispatch → 06:00 PT sweep; manual dispatch before today's sweep runs against a stale fulfillment_jobs table that has not yet received today's backfill. Wait for the 06:00 PT sweep cron, trigger sweep manually, or pass ?force=true after confirming coverage.",
  "dispatch.warn": "{{count}} warn",
  "dispatch.noOpenReviewItems": "No open review items",
  "dispatch.reviewItemsPending_one": "{{count}} review item pending",
  "dispatch.reviewItemsPending_other": "{{count}} review items pending",
  "dispatch.columnJobId": "Delivery Job ID",
  "dispatch.columnOrder": "Order",
  "dispatch.columnRecipient": "Recipient",
  "dispatch.columnAddress": "Address",
  "dispatch.columnDeliveryDate": "Delivery Date",
  "dispatch.noPlannedJobs": "No to-dispatch delivery jobs for {{date}}",
  "dispatch.dispatchCompleted": "Dispatch Completed",
  "dispatch.dispatchPartial": "Dispatch Incomplete",
  "dispatch.runSummary": "Dispatched {{dispatched}} for {{date}}.",
  "dispatch.runPartialSummary": "Dispatched {{dispatched}} for {{date}}; {{remaining}} still pending — retry after checking Onfleet.",
  "dispatch.noResults": "No results returned",
  "dispatch.dispatchFailed": "Dispatch Failed",
  "dispatch.cancelJob": "Cancel",
  "dispatch.cancelJobTitle": "Cancel Delivery Job",
  "dispatch.cancelJobConfirm": "Cancel the to-dispatch delivery job for order {{order}} ({{id}})?",
  "dispatch.jobCancelled": "Delivery job cancelled",
  "dispatch.jobCancelledMsg": "The to-dispatch delivery job has been cancelled.",
  "dispatch.cancelFailed": "Cancel failed",
  "passwordChange.password": "Password",
  "passwordChange.passwordDesc": "Update your password to keep your account secure",
  "passwordChange.changePassword": "Change Password",
  "passwordChange.title": "Change Password",
  "passwordChange.subtitle": "Enter your current password and choose a new one",
  "passwordChange.currentPassword": "Current Password",
  "passwordChange.newPassword": "New Password",
  "passwordChange.confirmNewPassword": "Confirm New Password",
  "passwordChange.currentRequired": "Current password is required",
  "passwordChange.passwordInvalid": "Password does not meet requirements",
  "passwordChange.passwordMismatch": "Passwords do not match",
  "passwordChange.passwordSame": "New password must be different from current password",
  "passwordChange.updatePassword": "Update Password",
  "passwordChange.updating": "Updating...",
  "role.admin": "Admin",
  "role.admin.desc": "Full system access including user management, sync, and settings.",
  "role.operator": "Operator",
  "role.operator.desc": "Read all data; manage orders, dispatch, drivers, driver tasks, exceptions, and notes.",
  "role.viewer": "Viewer",
  "role.viewer.desc": "Read-only access to all data. No dispatch or management operations.",
  "perm.customers": "Customers",
  "perm.products": "Products",
  "perm.orders": "Orders",
  "perm.dispatch": "Dispatch",
  "perm.users": "Users",
  "perm.packaging": "Delivery Job Printout",
  "perm.review": "Operator Inbox",
  "perm.webhook_failures": "Webhook Failures",
  "perm.catalog": "Catalog",
  "perm.inventory": "Inventory",
  "perm.stocktake": "Stocktake",
  "perm.procurement": "Procurement",
  "perm.audit": "Change History",
  "perm.debug": "Trace",
  "status.completed": "Completed",
  "status.inProgress": "In Progress",
  "status.assigned": "Assigned",
  "status.cancelled": "Cancelled",
  "status.pending": "Pending",
  "status.unassigned": "Unassigned",
  "priority.high": "↑ High",
  "priority.low": "↓ Low",
  "priority.medium": "→ Medium",
  "op.contains": "Contains",
  "op.containsCI": "Contains (Case Insensitive)",
  "op.equals": "Equals",
  "op.notEquals": "Not Equals",
  "op.lessThan": "Less Than",
  "op.greaterThan": "Greater Than",
  "op.lessThanLex": "Less Than (Lexical)",
  "op.greaterThanLex": "Greater Than (Lexical)",
  "op.is": "Is",
  "op.isNot": "Is Not",
  "op.in": "In",
  "op.from": "From (>=)",
  "op.to": "To (<=)",
  "op.between": "Between",
  "op.equalsDay": "Equals (Day)",
  "auth.loginFailed": "Login failed",
  "auth.registrationFailed": "Registration failed",
  "auth.unexpectedSignIn": "An unexpected error occurred during sign-in.",
  "auth.unexpectedSignUp": "An unexpected error occurred during sign-up.",
  "auth.loadingAuth": "Loading authentication...",
  "auth.permissionsError.title": "Couldn't load permissions",
  "auth.permissionsError.message": "We couldn't load your access permissions. Check your connection and try again.",
  "auth.permissionsError.retry": "Retry",
  "auth.permissionsError.signOut": "Sign out",
  "resource.createFailed": "Create Failed",
  "resource.updateFailed": "Update Failed",
  "resource.editTitle": "Edit {{name}}",
  "resource.selectField": "Select {{field}}",
  "resource.validation.invalidType": "Value has the wrong type.",
  "resource.validation.tooSmall": "Value is too short.",
  "resource.validation.tooBig": "Value is too long.",
  "resource.validation.invalidOption": "Select a valid option.",
  "resource.validation.invalidFormat": "Value has an invalid format.",
  "resource.validation.unrecognizedField": "Unrecognized field.",
  "ui.na": "N/A",
  "driver.selector.title": "Select Driver",
  "driver.selector.allDrivers": "All drivers",
  "driver.selector.allDriversExport": "All drivers (export all data)",
  "driver.selector.loadFailed": "Failed to load drivers: {{error}}",
  "driver.selector.choose": "Choose driver",
  "driver.selector.noDrivers": "No drivers available for this date",
  "json.tableAria": "JSON data table",
  "json.copy": "Copy JSON",
  "json.copied": "Copied",
  "json.expand": "Expand",
  "json.diff.tableAria": "JSON comparison table",
  "json.diff.colKey": "Key",
  "json.diff.colBefore": "Before",
  "json.diff.colAfter": "After",
  "json.diff.onlyChanged": "Changed only",
  "json.diff.removed": "Removed",
  "json.diff.cleared": "Cleared",
  "json.diff.added": "Added",
  "json.diff.changed_one": "{{count}} change",
  "json.diff.changed_other": "{{count}} changes",
  "json.diff.moreRows_one": "+{{count}} more row",
  "json.diff.moreRows_other": "+{{count}} more rows",
  "users.inviteUserFailed": "Failed to invite user",
  "users.error.email_taken": "An account already uses that email address.",
  "users.updateUserFailed": "Failed to update user",
  "users.disableUserFailed": "Failed to disable user",
  "ui.saving": "Saving…",
  "nav.docs": "Documentation",
  "docs.title": "Documentation",
  "packaging.title": "Delivery Job Printout",
  "packaging.cutoff.title": "Post-cutoff order change detected",
  "packaging.cutoff.body_one": "{{count}} open post-cutoff exception affects orders on {{date}}. Click to review.",
  "packaging.cutoff.body_other": "{{count}} open post-cutoff exceptions affect orders on {{date}}. Click to review.",
  "packaging.dateLabel": "Date",
  "packaging.download.csv": "Download CSV",
  "packaging.print": "Print",
  "packaging.empty": "No delivery jobs matched.",
  "packaging.generatedAt": "Generated {{time}}",
  "packaging.group.unassigned": "Unassigned",
  "packaging.gift.badge": "Includes gift",
  "packaging.item.unallocated": "Unplaced",
  "packaging.card.orderNote": "Order note",
  "packaging.card.jobNote": "Delivery job note",
  "packaging.card.perDriverPageBreak": "Page break per driver",
  "packaging.error.loadFailed": "Failed to load delivery job printouts.",
  "packaging.export.success.title": "Export ready",
  "packaging.export.failed.title": "Export failed",
  "packaging.export.failed.body": "The CSV export could not be generated. Try again; if the problem persists, check the dev console.",
  "packaging.print.failed.title": "Could not open print preview",
  "packaging.print.failed.body": "The print preview failed to render. Try again; if the problem persists, check the dev console.",
  "packaging.print.popupBlocked.title": "Popup blocked",
  "packaging.print.popupBlocked.body": "Please allow pop-ups for this site so the print preview can open in a new tab.",
  "order.structure.title": "Delivery Jobs",
  "order.structure.noJobs": "No delivery jobs yet.",
  "order.structure.loading": "Loading delivery jobs…",
  "order.structure.errorLoad": "Could not load delivery jobs. Detail: {{detail}}",
  "order.structure.deliveryDate": "Delivery {{date}}",
  "order.structure.flexibleDate": "Flexible",
  "order.structure.presumedCoverage": "Same-address, same-day sibling {{order}} already has driver task {{task}}; this order is presumed covered by that trip.",
  "order.structure.toggleItems": "Line items",
  "order.structure.itemQuantity": "× {{quantity}}",
  "order.structure.itemUntitled": "(untitled item)",
  "order.structure.itemsEmpty": "This delivery job lists no line items.",
  "order.structure.itemsUnavailable": "This delivery job's line items could not be read (malformed data); it does not mean the job is empty.",
  "order.structure.unassignedItems": "Items not in any delivery job",
  "order.structure.gapUnavailable": "Some delivery job line items could not be read, so unassigned items cannot be computed.",
  "ingredient.label": "Ingredient",
  "ingredient.field.id": "ID",
  "ingredient.field.name": "Name",
  "ingredient.field.unit": "Unit",
  "ingredient.field.category": "Category",
  "ingredient.field.storage": "Storage",
  "ingredient.field.shelfLifeDays": "Shelf life (days)",
  "ingredient.field.defaultSupplierId": "Default supplier",
  "ingredient.field.safetyStock": "Safety stock",
  "ingredient.field.photoUrl": "Photo URL",
  "ingredient.field.notes": "Notes",
  "ingredient.field.createdAt": "Created at",
  "ingredient.field.updatedAt": "Updated at",
  "ingredient.enum.storage.ambient": "Ambient",
  "ingredient.enum.storage.chilled": "Chilled",
  "ingredient.enum.storage.frozen": "Frozen",
  "ingredient.enum.unit.g": "g",
  "ingredient.enum.unit.kg": "kg",
  "ingredient.enum.unit.ml": "ml",
  "ingredient.enum.unit.l": "L",
  "ingredient.enum.unit.piece": "Piece",
  "ingredient.enum.unit.bunch": "Bunch",
  "ingredient.enum.category.protein": "Protein",
  "ingredient.enum.category.vegetable": "Vegetable",
  "ingredient.enum.category.seasoning": "Seasoning",
  "ingredient.enum.category.sauce": "Sauce",
  "ingredient.enum.category.staple": "Staple",
  "ingredient.enum.category.other": "Other",
  "ingredient.group.identity": "Basic Info",
  "ingredient.group.meta": "Metadata",
  "ingredient.searchPlaceholder": "Search ingredients by name or note…",
  "ingredient.form.createTitle": "Create ingredient",
  "ingredient.form.editTitle": "Edit ingredient",
  "supplier.label": "Supplier",
  "supplier.field.id": "ID",
  "supplier.field.name": "Name",
  "supplier.field.contact": "Contact",
  "supplier.field.phone": "Phone",
  "supplier.field.email": "Email",
  "supplier.field.leadTimeDays": "Lead time (days)",
  "supplier.field.minOrderValue": "Min order value",
  "supplier.field.currency": "Currency",
  "supplier.field.paymentTerms": "Payment terms",
  "supplier.field.status": "Status",
  "supplier.field.createdAt": "Created at",
  "supplier.field.updatedAt": "Updated at",
  "supplier.enum.status.active": "Active",
  "supplier.enum.status.paused": "Paused",
  "supplier.group.identity": "Basic Info",
  "supplier.group.meta": "Metadata",
  "supplier.searchPlaceholder": "Search suppliers by name, contact, or email…",
  "supplier.form.createTitle": "Create supplier",
  "supplier.form.editTitle": "Edit supplier",
  "nav.catalog": "Catalog",
  "nav.catalog.ingredients": "Ingredients",
  "nav.catalog.suppliers": "Suppliers",
  "nav.catalog.dishes": "Dishes",
  "nav.catalog.combos": "Combos",
  "nav.menuPlanning": "Menu Planning",
  "nav.menuPlanning.plans": "Weekly Plans",
  "nav.inventory": "Inventory",
  "nav.inventory.stock": "Stock Levels",
  "nav.procurement.section": "Procurement",
  "nav.procurement.suggestions": "Suggestions",
  "nav.procurement.purchaseOrders": "Purchase Orders",
  "procurement.common.refresh": "Refresh",
  "procurement.suggestions.title": "Purchase Suggestions",
  "procurement.suggestions.subtitle": "Operator-actionable queue from the forecaster. Enter a unit price then accept a row to create a draft purchase order, or dismiss it.",
  "procurement.suggestions.empty": "No pending suggestions.",
  "procurement.suggestions.loadError": "Failed to load suggestions. Try refreshing.",
  "procurement.suggestions.accept": "Accept",
  "procurement.suggestions.dismiss": "Dismiss",
  "procurement.suggestions.acceptSuccess": "Suggestion accepted. A draft purchase order was created.",
  "procurement.suggestions.dismissSuccess": "Suggestion dismissed.",
  "procurement.suggestions.priceRequired": "Enter a unit price before accepting.",
  "procurement.suggestions.invalidPrice": "Unit price must be a positive number.",
  "procurement.suggestions.unitPricePh": "Unit price",
  "procurement.suggestions.supplier": "Supplier: {{supplier}}",
  "procurement.suggestions.lineCount_one": "{{count}} line",
  "procurement.suggestions.lineCount_other": "{{count}} lines",
  "procurement.suggestions.viewPOs": "View purchase orders →",
  "procurement.suggestions.col.ingredient": "Ingredient",
  "procurement.suggestions.col.suggestedQty": "Suggested Qty",
  "procurement.suggestions.col.unit": "Unit",
  "procurement.suggestions.col.unitPrice": "Unit Price",
  "procurement.suggestions.col.actions": "Actions",
  "procurement.purchaseOrders.title": "Purchase Orders",
  "procurement.purchaseOrders.subtitle": "Filter by status / supplier. Click a row to view line items and start a delivery receipt.",
  "procurement.purchaseOrders.empty": "No purchase orders match the current filter.",
  "procurement.purchaseOrders.loadError": "Failed to load purchase orders. Try refreshing.",
  "procurement.purchaseOrders.receive": "Receive goods",
  "procurement.purchaseOrders.submit": "Submit",
  "procurement.purchaseOrders.cancel": "Cancel",
  "procurement.purchaseOrders.close": "Close",
  "procurement.purchaseOrders.submitSuccess": "Purchase order submitted.",
  "procurement.purchaseOrders.cancelSuccess": "Purchase order cancelled.",
  "procurement.purchaseOrders.closeSuccess": "Purchase order closed.",
  "procurement.purchaseOrders.detailTitle": "Purchase order {{id}}",
  "procurement.purchaseOrders.linesTitle": "Line items",
  "procurement.purchaseOrders.noLines": "This purchase order has no line items.",
  "procurement.purchaseOrders.col.id": "PO id",
  "procurement.purchaseOrders.col.supplier": "Supplier",
  "procurement.purchaseOrders.col.status": "Status",
  "procurement.purchaseOrders.col.orderedAt": "Ordered at",
  "procurement.purchaseOrders.col.total": "Total",
  "procurement.purchaseOrders.col.expectedDeliveryAt": "Expected delivery",
  "procurement.purchaseOrders.col.receivedAt": "Received at",
  "procurement.purchaseOrders.col.currency": "Currency",
  "procurement.purchaseOrders.col.notes": "Notes",
  "procurement.purchaseOrders.col.createdAt": "Created at",
  "procurement.purchaseOrders.col.updatedAt": "Updated at",
  "procurement.purchaseOrders.col.ingredient": "Ingredient",
  "procurement.purchaseOrders.col.qtyOrdered": "Ordered",
  "procurement.purchaseOrders.col.qtyReceived": "Received",
  "procurement.purchaseOrders.col.unit": "Unit",
  "procurement.receive.title": "Receive Goods",
  "procurement.receive.subtitle": "Recording delivery for PO {{id}}.",
  "procurement.receive.lines": "Lines awaiting receipt",
  "procurement.receive.allReceived": "Every line on this PO has been fully received.",
  "procurement.receive.linePrompt": "Remaining: {{remaining}} {{unit}}",
  "procurement.receive.keypadFor": "Entry: {{ingredient}}",
  "procurement.receive.keypadIdle": "Numeric keypad",
  "procurement.receive.keypadKey": "Key {{key}}",
  "procurement.receive.backspace": "Backspace",
  "procurement.receive.clear": "Clear",
  "procurement.receive.fill": "Fill remaining",
  "procurement.receive.next": "Next line",
  "procurement.receive.cancel": "Cancel",
  "procurement.receive.submit_one": "Submit receipt ({{count}} line)",
  "procurement.receive.submit_other": "Submit receipt ({{count}} lines)",
  "procurement.receive.submitSuccess": "Receipt recorded. PO status: {{status}}.",
  "procurement.receive.invalidQty": "Enter a positive quantity before pressing Next.",
  "procurement.receive.overflow": "Quantity exceeds the remaining amount on this line.",
  "procurement.receive.missingId": "Missing PO id in the URL.",
  "procurement.receive.loadError": "Failed to load purchase order.",
  "procurement.status.draft": "Draft",
  "procurement.status.submitted": "Submitted",
  "procurement.status.partially_received": "Partially received",
  "procurement.status.received": "Received",
  "procurement.status.cancelled": "Cancelled",
  "procurement.status.closed": "Closed",
  "nav.stocktake.section": "Stocktake",
  "nav.stocktake.list": "Stocktake",
  "stocktake.common.refresh": "Refresh",
  "stocktake.status.open": "Open",
  "stocktake.status.counted": "Counted",
  "stocktake.status.committed": "Committed",
  "stocktake.status.cancelled": "Cancelled",
  "stocktake.list.title": "Stocktake",
  "stocktake.list.subtitle": "Weekly count + variance review. Click a row to continue counting or review its variances.",
  "stocktake.list.loadError": "Failed to load stocktakes. Try refreshing.",
  "stocktake.list.openWeekLabel": "Week starting",
  "stocktake.list.openButton": "Open stocktake",
  "stocktake.list.openSuccess": "Stocktake opened for week {{week}}.",
  "stocktake.list.col.week": "Week",
  "stocktake.list.col.status": "Status",
  "stocktake.list.col.openedAt": "Opened",
  "stocktake.list.col.closedAt": "Closed",
  "stocktake.list.col.openedBy": "Opened by",
  "stocktake.count.title": "Count — week of {{week}}",
  "stocktake.count.subtitle_one": "Status: {{status}} · {{remaining}} of {{count}} line uncounted.",
  "stocktake.count.subtitle_other": "Status: {{status}} · {{remaining}} of {{count}} lines uncounted.",
  "stocktake.count.back": "Back to stocktake list",
  "stocktake.count.cancelStocktake": "Cancel stocktake",
  "stocktake.count.cancelConfirm": "Cancel this stocktake? Any entered counts will be discarded and no ledger adjustment will be made.",
  "stocktake.count.cancelSuccess": "Stocktake cancelled.",
  "stocktake.count.reviewLink": "Review variance",
  "stocktake.count.lines": "Ingredients",
  "stocktake.count.emptyLines": "No ingredients on this stocktake.",
  "stocktake.count.focusLine": "Focus {{ingredient}}",
  "stocktake.count.systemQty": "System: {{qty}}",
  "stocktake.count.counted": "Counted",
  "stocktake.count.uncounted": "Uncounted",
  "stocktake.count.keypadFor": "Entry: {{ingredient}}",
  "stocktake.count.keypadIdle": "Numeric keypad",
  "stocktake.count.keypadKey": "Key {{key}}",
  "stocktake.count.backspace": "Backspace",
  "stocktake.count.clear": "Clear",
  "stocktake.count.matchSystem": "Match system",
  "stocktake.count.next": "Next line",
  "stocktake.count.save": "Save counts ({{count}})",
  "stocktake.count.saveSuccess_one": "Saved {{count}} count.",
  "stocktake.count.saveSuccess_other": "Saved {{count}} counts.",
  "stocktake.count.invalidQty": "Counted quantity for {{ingredient}} must be a non-negative number.",
  "stocktake.count.nothingToSave": "Type a count before saving.",
  "stocktake.count.partialSaveFailure_one": "Saved {{saved}} of {{count}} line; the rest failed. Retry to save the remainder.",
  "stocktake.count.partialSaveFailure_other": "Saved {{saved}} of {{count}} lines; the rest failed. Retry to save the remainder.",
  "stocktake.count.missingId": "Missing stocktake id in the URL.",
  "stocktake.count.loadError": "Failed to load stocktake.",
  "stocktake.review.title": "Review — week of {{week}}",
  "stocktake.review.subtitle": "{{positive}} up · {{negative}} down · {{zero}} match · {{uncounted}} uncounted.",
  "stocktake.review.back": "Back to stocktake list",
  "stocktake.review.backToCount": "Back to count",
  "stocktake.review.positiveGroup": "Surplus ({{count}})",
  "stocktake.review.negativeGroup": "Shortfall ({{count}})",
  "stocktake.review.zeroGroup": "No variance ({{count}})",
  "stocktake.review.uncountedGroup": "Uncounted ({{count}})",
  "stocktake.review.col.ingredient": "Ingredient",
  "stocktake.review.col.systemQty": "System",
  "stocktake.review.col.countedQty": "Counted",
  "stocktake.review.col.varianceQty": "Variance",
  "stocktake.review.commitTitle": "Commit stocktake",
  "stocktake.review.commitWarning": "Lines that will adjust the inventory ledger: {{nonZero}}. Uncounted lines (no adjustment): {{uncounted}}. This action is not reversible.",
  "stocktake.review.confirmCheckbox": "I have reviewed the variances and want to close & adjust the ledger.",
  "stocktake.review.confirmRequired": "Tick the confirmation box before committing.",
  "stocktake.review.commitButton": "Close & adjust ledger",
  "stocktake.review.commitSuccess": "Stocktake committed. Ledger updated.",
  "stocktake.review.cancelStocktake": "Cancel stocktake",
  "stocktake.review.cancelConfirm": "Cancel this stocktake? Any entered counts will be discarded and no ledger adjustment will be made.",
  "stocktake.review.cancelSuccess": "Stocktake cancelled.",
  "stocktake.review.missingId": "Missing stocktake id in the URL.",
  "stocktake.review.loadError": "Failed to load stocktake.",
  "inventory.stock.title": "Stock Levels",
  "inventory.stock.tableTitle": "On-hand by ingredient",
  "inventory.stock.refresh": "Refresh",
  "inventory.stock.empty": "No ingredients to display.",
  "inventory.stock.loadError": "Failed to load stock levels. Try refreshing — if it persists, escalate to ops.",
  "inventory.stock.onHandUnavailableTitle": "On-hand quantities unavailable",
  "inventory.stock.onHandUnavailableDetail": "The rebuilt backend does not yet provide a batch on-hand endpoint, so per-ingredient stock levels are not shown here. This will return once that endpoint is built (tracked as #935/#936).",
  "inventory.stock.truncatedTitle": "Catalog truncated",
  "inventory.stock.truncatedDetail": "Showing the first {{shown}} of {{total}} ingredients. Larger-catalog support is tracked as a follow-up.",
  "inventory.stock.col.name": "Ingredient",
  "inventory.stock.col.unit": "Unit",
  "inventory.stock.col.category": "Category",
  "inventory.stock.col.onHand": "On-hand",
  "menu_plan.label": "Menu plan",
  "menu_plan.searchPlaceholder": "Search by week start date…",
  "menu_plan.field.id": "ID",
  "menu_plan.field.weekStart": "Week starts",
  "menu_plan.field.status": "Status",
  "menu_plan.field.approvedBy": "Approved by",
  "menu_plan.field.approvedAt": "Approved at",
  "menu_plan.field.publishedAt": "Published at",
  "menu_plan.field.createdAt": "Created at",
  "menu_plan.field.updatedAt": "Updated at",
  "menu_plan.group.identity": "Basic Info",
  "menu_plan.group.lifecycle": "Lifecycle",
  "menu_plan.group.meta": "Metadata",
  "menu_plan.enum.status.draft": "Draft",
  "menu_plan.enum.status.approved": "Approved",
  "menu_plan.enum.status.published": "Published",
  "menu_plan.enum.itemStatus.planned": "Planned",
  "menu_plan.enum.itemStatus.amended": "Amended",
  "menu_plan.enum.itemStatus.requires_review": "Requires review",
  "menu_plan.items.tabLabel": "Menu items",
  "menu_plan.items.title": "Menu items ({{count}})",
  "menu_plan.items.empty": "No menu items in this plan yet.",
  "menu_plan.items.noDishes": "—",
  "menu_plan.items.col.deliveryDate": "Delivery date",
  "menu_plan.items.col.combo": "Combo",
  "menu_plan.items.col.dishes": "Dishes",
  "menu_plan.items.col.status": "Status",
  "menu_plan.reviewReason.catalog.dish_archived": "Dish was archived — combo references a dish no longer available",
  "menu_plan.reviewReason.catalog.ingredient_archived": "Ingredient was archived — a dish in this combo references an ingredient no longer available",
  "menu_plan.action.approve.button": "Approve",
  "menu_plan.action.approve.confirmTitle": "Approve menu plan?",
  "menu_plan.action.approve.confirmMessage": "Approve the plan for week starting {{weekStart}}? Ops manager grants pass after this step.",
  "menu_plan.action.approve.confirmAction": "Approve",
  "menu_plan.action.approve.success": "Plan approved",
  "menu_plan.action.approve.failure": "Approve failed",
  "menu_plan.action.publish.button": "Publish",
  "menu_plan.action.publish.confirmTitle": "Publish menu plan?",
  "menu_plan.action.publish.confirmMessage": "Publish the plan for week starting {{weekStart}}? This will create Shopify products for each menu item. The action is reversible via Unpublish.",
  "menu_plan.action.publish.confirmAction": "Publish",
  "menu_plan.action.publish.success": "Plan published",
  "menu_plan.action.publish.successButFanoutFailed": "Plan published, but downstream Shopify fanout failed. Use Retry fanout below.",
  "menu_plan.action.publish.emitFailedBanner": "The plan published, but the downstream Shopify product creation failed.",
  "menu_plan.action.publish.failure": "Publish failed",
  "menu_plan.action.unpublish.button": "Unpublish",
  "menu_plan.action.unpublish.confirmTitle": "Unpublish menu plan?",
  "menu_plan.action.unpublish.confirmMessage": "Unpublish the plan for week starting {{weekStart}}? Shopify products will be hidden but their IDs and URLs are preserved (no customer-facing 404s).",
  "menu_plan.action.unpublish.confirmAction": "Unpublish",
  "menu_plan.action.unpublish.success": "Plan unpublished",
  "menu_plan.action.unpublish.successButFanoutFailed": "Plan unpublished, but downstream Shopify fanout failed. Use Retry fanout below.",
  "menu_plan.action.unpublish.emitFailedBanner": "The plan was unpublished, but hiding the Shopify products failed.",
  "menu_plan.action.unpublish.failure": "Unpublish failed",
  "menu_plan.action.republishFanout.button": "Retry fanout",
  "menu_plan.action.republishFanout.success": "Fanout retried successfully",
  "menu_plan.action.republishFanout.partial": "Retried — some items still failed to sync. Try again once resolved.",
  "menu_plan.action.republishFanout.failure": "Retry failed — see error toast",
  "menu_plan.action.emitFailed.explanation": "The plan state has already changed; click below to re-emit the lifecycle event without re-running the transition.",
  "menu_plan.action.error.invalidTransition": "Invalid state transition: {{from}} → {{to}}",
  "menu_plan.action.error.emitFailed": "Downstream fanout failed: {{message}}",
  "menu_plan.create.openButton": "New plan",
  "menu_plan.create.title": "Create menu plan",
  "menu_plan.create.description": "Create a draft plan for a specific week. The week must start on a Monday.",
  "menu_plan.create.weekStartPlaceholder": "Pick a Monday",
  "menu_plan.create.weekStartHint": "ISO Monday — e.g. 2026-05-11. Only one live plan per week is allowed.",
  "menu_plan.create.submit": "Create draft",
  "menu_plan.create.submitting": "Creating…",
  "menu_plan.create.success": "Draft plan created",
  "menu_plan.create.error.required": "Pick a week start date.",
  "menu_plan.create.error.notMonday": "The week must start on a Monday.",
  "menu_plan.create.error.weekCollision": "A plan for week {{weekStart}} already exists. Open the existing plan instead of creating a duplicate.",
  "menu_plan.create.error.unknown": "Failed to create plan — please try again.",
  "menu_plan.items.col.actions": "Actions",
  "menu_plan.amend.openButton": "Amend",
  "menu_plan.amend.title": "Amend menu item",
  "menu_plan.amend.description": "Swap a dish in this published menu item (delivery {{deliveryDate}}). INV-M2-9 restricts amend to today and tomorrow in the merchant timezone.",
  "menu_plan.amend.outOfWindowBanner": "Delivery {{deliveryDate}} is outside the amend window (today / tomorrow only).",
  "menu_plan.amend.fromLabel": "Dish to swap out",
  "menu_plan.amend.fromPlaceholder": "Select a dish currently in this item",
  "menu_plan.amend.fromHint": "Only dishes already in this menu item are eligible.",
  "menu_plan.amend.toLabel": "Replacement dish ID",
  "menu_plan.amend.toPlaceholder": "e.g. d-kungpao",
  "menu_plan.amend.toHint": "Enter the ID of the replacement dish from the catalog.",
  "menu_plan.amend.submit": "Amend item",
  "menu_plan.amend.submitting": "Amending…",
  "menu_plan.amend.success": "Menu item amended",
  "menu_plan.amend.successButFanoutFailed": "Menu item amended, but downstream Shopify sync failed — open the plan to retry.",
  "menu_plan.amend.error.fromRequired": "Pick a dish to swap out.",
  "menu_plan.amend.error.toRequired": "Enter the replacement dish ID.",
  "menu_plan.amend.error.sameDish": "Replacement dish must differ from the dish being swapped out.",
  "menu_plan.amend.error.outOfWindowLocal": "Delivery date is outside today / tomorrow. Amend is not allowed.",
  "menu_plan.amend.error.outOfWindow": "Delivery {{deliveryDate}} is outside the amend window (allowed: {{today}}, {{tomorrow}}).",
  "menu_plan.amend.error.dishNotFound": "Dish {{dishId}} was not found in the catalog (it may have been archived).",
  "menu_plan.amend.error.dishNotInSnapshot": "Dish {{dishId}} is not in this item's current snapshot.",
  "menu_plan.amend.error.planNotPublished": "Plan is not published (current state: {{currentStatus}}).",
  "menu_plan.amend.error.unknown": "Amend failed — please try again.",
  "menu_plan.amend.reasonLabel": "Reason",
  "menu_plan.amend.reasonPlaceholder": "Select a reason…",
  "menu_plan.amend.reason.combo_changed": "Combo changed",
  "menu_plan.amend.reason.dish_substituted": "Dish substituted",
  "menu_plan.amend.reason.cancelled": "Cancelled",
  "menu_plan.amend.dishesLabel": "Dish snapshot (JSON)",
  "menu_plan.amend.dishesHint": "Edit the item's dish list as a JSON array. Saving re-renders the linked Shopify product title.",
  "menu_plan.amend.successNotLinked": "Item amended (no linked Shopify product to update).",
  "menu_plan.amend.error.reasonRequired": "Select a reason for this amendment.",
  "menu_plan.amend.error.dishesRequired": "The dish snapshot cannot be empty.",
  "menu_plan.amend.error.invalidJson": "The dish snapshot must be a valid JSON array.",
  "menu_plan.weekPage.title": "Week starting {{weekStart}}",
  "menu_plan.weekPage.subtitle": "Status: {{status}}",
  "menu_plan.weekPage.emptyDay": "No items.",
  "menu_plan.weekPage.addButton": "Add",
  "menu_plan.weekPage.deleteSuccess": "Menu item removed",
  "menu_plan.weekPage.deleteFailure": "Failed to remove menu item",
  "menu_plan.weekPage.deletePlanNotDraft": "Cannot delete: plan is no longer in draft (current state: {{currentStatus}}). Unpublish first.",
  "menu_plan.weekPage.deleteConfirmTitle": "Remove menu item?",
  "menu_plan.weekPage.deleteConfirmMessage": "Remove combo {{comboId}} from {{deliveryDate}}? The plan must be in draft for this to succeed.",
  "menu_plan.weekPage.weekday.monday": "Monday",
  "menu_plan.weekPage.weekday.tuesday": "Tuesday",
  "menu_plan.weekPage.weekday.wednesday": "Wednesday",
  "menu_plan.weekPage.weekday.thursday": "Thursday",
  "menu_plan.weekPage.weekday.friday": "Friday",
  "menu_plan.weekPage.weekday.saturday": "Saturday",
  "menu_plan.weekPage.weekday.sunday": "Sunday",
  "menu_plan.weekPage.openButton": "Week view",
  "menu_plan.upsertItem.titleCreate": "Add menu item",
  "menu_plan.upsertItem.titleEdit": "Edit menu item",
  "menu_plan.upsertItem.description": "Slot a combo into delivery {{deliveryDate}}. One combo per (date, plan) — the backend rejects collisions with a 409.",
  "menu_plan.upsertItem.comboLabel": "Combo",
  "menu_plan.upsertItem.comboPlaceholder": "Select a combo",
  "menu_plan.upsertItem.comboLoading": "Loading combos…",
  "menu_plan.upsertItem.comboHint": "Only active combos are listed. Archived combos are excluded by the backend filter.",
  "menu_plan.upsertItem.submitCreate": "Add item",
  "menu_plan.upsertItem.submitEdit": "Save changes",
  "menu_plan.upsertItem.submitting": "Saving…",
  "menu_plan.upsertItem.successCreate": "Menu item added",
  "menu_plan.upsertItem.successEdit": "Menu item updated",
  "menu_plan.upsertItem.error.comboRequired": "Pick a combo to add.",
  "menu_plan.upsertItem.error.planNotDraft": "Plan is not in draft (current state: {{currentStatus}}); item edits are only allowed on draft plans.",
  "menu_plan.upsertItem.error.slotCollision": "A menu item with combo {{comboId}} already exists on {{deliveryDate}}. Edit the existing item instead of adding a duplicate.",
  "menu_plan.upsertItem.error.unknown": "Failed to save menu item — please try again.",
  "menu_plan.reviewPage.title": "Review — week of {{weekStart}}",
  "menu_plan.reviewPage.subtitle": "Planning-time ingredient projection. Adjust the estimated daily orders to preview supply needs at any workflow stage (draft / approved / published).",
  "menu_plan.reviewPage.estimateCardTitle": "Projection input",
  "menu_plan.reviewPage.estimateLabel": "Estimated daily orders",
  "menu_plan.reviewPage.resetButton": "Reset to {{value}}",
  "menu_plan.reviewPage.estimateInvalid": "Enter a non-negative integer up to {{max}}.",
  "menu_plan.reviewPage.costColumnNotice": "Cost projection (price × qty) is deferred to M3 Procurement — this view shows quantities only.",
  "menu_plan.reviewPage.tableCardTitle": "Ingredient needs ({{count}})",
  "menu_plan.reviewPage.columnIngredient": "Ingredient",
  "menu_plan.reviewPage.columnQty": "Total qty",
  "menu_plan.reviewPage.columnUnit": "Unit",
  "menu_plan.reviewPage.unitBreakdown": "Breakdown by unit: {{breakdown}}.",
  "menu_plan.reviewPage.emptyPlan": "No menu items yet. Add combos in the week view first.",
  "menu_plan.reviewPage.emptyPlanCta": "Open week view",
  "menu_plan.reviewPage.emptyNeeds": "No ingredient needs computed — the combos in this plan have no recipe lines yet.",
  "menu_plan.reviewPage.openButton": "Review needs",
  "menu_plan.reviewPage.linkLabel": "Open the ingredient-needs projection for this week.",
  "menu_plan.reviewPage.error404": "This plan has been deleted. Return to the plan list to pick another.",
  "menu_plan.reviewPage.errorGeneric": "Could not load ingredient needs. Try adjusting the estimated daily orders, or retry in a moment.",
  "dish.label": "Dish",
  "dish.field.id": "ID",
  "dish.field.name": "Name",
  "dish.field.nameZh": "Name (中文)",
  "dish.field.nameEn": "Name (English)",
  "dish.field.category": "Category",
  "dish.field.portionGrams": "Portion (g)",
  "dish.field.cookTimeMin": "Cook time (min)",
  "dish.field.description": "Description",
  "dish.field.status": "Status",
  "dish.field.createdAt": "Created at",
  "dish.field.updatedAt": "Updated at",
  "dish.enum.status.active": "Active",
  "dish.enum.status.archived": "Archived",
  "dish.enum.category.stir_fry": "Stir-fry",
  "dish.enum.category.soup": "Soup",
  "dish.enum.category.cold": "Cold dish",
  "dish.enum.category.staple": "Staple",
  "dish.enum.category.other": "Other",
  "dish.group.identity": "Basic Info",
  "dish.group.meta": "Metadata",
  "dish.searchPlaceholder": "Search dishes by name…",
  "dish.form.createTitle": "Create dish",
  "dish.form.editTitle": "Edit dish",
  "dish.recipe.title": "Recipe lines",
  "dish.recipe.empty": "No recipe lines yet — add one to get started.",
  "dish.recipe.ingredient": "Ingredient",
  "dish.recipe.qty": "Qty / portion",
  "dish.recipe.unit": "Unit",
  "dish.recipe.prepNote": "Prep note",
  "dish.recipe.prepNotePlaceholder": "diced / sliced / …",
  "dish.recipe.addRow": "Add ingredient",
  "dish.recipe.save": "Save recipe",
  "dish.recipe.saved": "Recipe saved.",
  "dish.recipe.saveFailed": "Failed to save recipe",
  "dish.recipe.loadFailed": "Failed to load recipe — please retry.",
  "dish.recipe.catalogTruncatedTitle": "Ingredient list truncated",
  "dish.recipe.catalogTruncatedDetail": "Showing the first {{shown}} of {{total}} ingredients. Some entries may be unreachable until typeahead lands (M2).",
  "dish.recipe.error.line.ingredientMissing": "{{ingredient}} — ingredient not found.",
  "dish.recipe.error.line.unitMismatch": "{{ingredient}} — unit must be {{expected}}, got {{got}}.",
  "dish.recipe.error.line.duplicate": "{{ingredient}} — appears more than once.",
  "dish.recipe.savedWithSkippedTitle": "Some rows were skipped",
  "dish.recipe.savedWithSkippedDetail_one": "{{count}} row was missing ingredient, qty, or unit and was not saved.",
  "dish.recipe.savedWithSkippedDetail_other": "{{count}} rows were missing ingredient, qty, or unit and were not saved.",
  "combo.label": "Combo",
  "combo.field.id": "ID",
  "combo.field.code": "Code",
  "combo.field.name": "Name",
  "combo.field.description": "Description",
  "combo.field.price": "Price",
  "combo.field.status": "Status",
  "combo.field.createdAt": "Created at",
  "combo.field.updatedAt": "Updated at",
  "combo.enum.status.active": "Active",
  "combo.enum.status.archived": "Archived",
  "combo.group.identity": "Basic Info",
  "combo.group.meta": "Metadata",
  "combo.searchPlaceholder": "Search combos by name or code…",
  "combo.form.createTitle": "Create combo",
  "combo.form.editTitle": "Edit combo",
  "combo.slots.title": "Slot assignments",
  "combo.slots.empty": "No slots yet — add a row to compose this set.",
  "combo.slots.slot": "Slot",
  "combo.slots.enum.main": "1st main",
  "combo.slots.enum.main2": "2nd main",
  "combo.slots.enum.main3": "3rd main",
  "combo.slots.enum.side": "Side",
  "combo.slots.enum.soup": "Soup",
  "combo.slots.enum.staple": "Staple",
  "combo.slots.dish": "Dish",
  "combo.slots.displayOrder": "Display order",
  "combo.slots.addRow": "Add slot",
  "combo.slots.save": "Save slots",
  "combo.slots.saved": "Slots saved.",
  "combo.slots.saveFailed": "Failed to save slots",
  "combo.slots.loadFailed": "Failed to load slots — please retry.",
  "combo.slots.catalogTruncatedTitle": "Dish list truncated",
  "combo.slots.catalogTruncatedDetail": "Showing the first {{shown}} of {{total}} active dishes. Some entries may be unreachable until typeahead lands (M2).",
  "combo.slots.error.line.dishMissing": "{{dish}} — dish not found.",
  "combo.slots.error.line.dishInactive": "{{dish}} — dish is archived; only active dishes can be slotted.",
  "combo.slots.error.line.duplicate": "{{slot}} / {{dish}} — duplicate (slot, dish) pair.",
  "combo.slots.savedWithSkippedTitle": "Some rows were skipped",
  "combo.slots.savedWithSkippedDetail_one": "{{count}} row was missing slot or dish and was not saved.",
  "combo.slots.savedWithSkippedDetail_other": "{{count}} rows were missing slot or dish and were not saved.",
  "ui.remove": "Remove",
  "dispatch.dispatchable": "Dispatchable",
  "dispatch.stopAlreadyDispatchedTitle": "Same address already dispatched ({{count}})",
  "dispatch.stopAlreadyDispatchedReason": "Same address as {{orderName}}, whose driver task is already dispatched; this delivery job will be dispatched as its own driver task (except an original delivery job left by an interrupted run, which rejoins that driver task). If the delivery job of {{orderName}} was dispatched on its own (not merged), these same-address delivery jobs may instead be merged into one new driver task",
  "dispatch.columnReason": "Reason",
  "dispatch.anomalyReason.order_not_found": "Order not found; the delivery job is still awaiting dispatch",
  "dispatch.anomalyReason.order_cancelled": "Order cancelled in Shopify; the delivery job is still awaiting dispatch",
  "dispatch.undated.title": "Undated Orders",
  "dispatch.undated.count_one": "{{count}} order",
  "dispatch.undated.count_other": "{{count}} orders",
  "dispatch.undated.subtitle": "No delivery date and no delivery job. Every day shows the same list; an order joins this day only when you schedule it here",
  "dispatch.undated.schedule": "Schedule for this day",
  "dispatch.undated.scheduleAll": "Schedule all for this day",
  "dispatch.undated.retry": "Retry",
  "dispatch.undated.failed": "Not scheduled:",
  "dispatch.undated.pastCutoff": "Past the {{at}} dispatch cutoff — you can still schedule into today; check before you dispatch",
  "dispatch.preCheck.title": "Check before dispatching",
  "dispatch.preCheck.subtitle": "Pre-dispatch errors make that batch fail and must be fixed first; the rest are reminders",
  "dispatch.preCheck.anomalies": "Pre-dispatch errors · fix first · {{count}}",
  "dispatch.preCheck.anomaliesSource": "Source: dispatch preview · order cancelled / order not found",
  "dispatch.preCheck.cancelJob": "Cancel delivery job",
  "dispatch.preCheck.shopify": "Differs from Shopify · {{count}}",
  "dispatch.preCheck.shopifySource": "Source: today’s demand (Shopify reconciliation)",
  "dispatch.preCheck.unpaidWhy": "Unpaid · financial_status = {{status}}",
  "dispatch.preCheck.missingJobWhy": "Shopify has this order’s items for the day, but there is no delivery job",
  "dispatch.preCheck.openOrder": "Open order",
  "dispatch.preCheck.multiQty": "Several of one product · {{count}}",
  "dispatch.preCheck.multiQtySource": "Source: today’s demand",
  "dispatch.preCheck.soldOut": "Sold out · {{count}}",
  "dispatch.preCheck.soldOutSource": "Source: today’s demand · products at 0 stock",
  "dispatch.preCheck.loadFailed": "Could not load this check. Try again.",
  "dispatch.jobsListHint": "Cancel or reschedule individual delivery jobs in the Delivery Jobs list.",
  "dispatch.board.title": "Batch board",
  "dispatch.board.nextGate": "Next deadline",
  "dispatch.board.yesterday": "Yesterday",
  "dispatch.board.today": "Today",
  "dispatch.board.dayLabel": "{{weekday}} {{md}}",
  "dispatch.board.collapsed": "{{from}} – {{to}} · no delivery jobs, folded (a day with jobs shows as a normal row)",
  "dispatch.board.restDay": "{{date}} · no deliveries (rest day)",
  "dispatch.board.restDayBadge": "Rest day",
  "dispatch.board.collapsedOne": "{{from}} · no delivery jobs",
  "dispatch.board.error": "Couldn't load the batch board.",
  "dispatch.board.cell": "{{date}}, {{stage}}: {{count}}",
  "dispatch.board.cellNone": "{{date}}, {{stage}}: none",
  "dispatch.board.stage.awaiting_dispatch": "To dispatch",
  "dispatch.board.stage.awaiting_assignment": "Awaiting driver",
  "dispatch.board.stage.awaiting_departure": "Ready to depart",
  "dispatch.board.stage.en_route": "On the road",
  "dispatch.board.stage.delivered": "Delivered",
  "dispatch.board.stage.exception_or_cancelled": "Exception or cancelled",
  "dispatch.board.gate.packaging_cutoff": "Delivery job printout cutoff {{at}}",
  "dispatch.board.gate.dispatch_cutoff": "Dispatch cutoff {{at}}",
  "dispatch.board.gate.delivery_window_end": "Delivery window ends {{at}}",
  "dispatch.board.focus.title": "Needs attention now",
  "dispatch.board.focus.allClear": "Nothing needs attention right now.",
  "dispatch.phone.step.intake": "Intake",
  "dispatch.phone.step.dispatch": "Dispatch",
  "dispatch.phone.step.assign": "Assign",
  "dispatch.phone.step.print": "Print",
  "dispatch.phone.step.deliver": "Deliver",
  "dispatch.phone.step.close": "Close",
  "dispatch.phone.headline.lateSuffix_one": ", {{count}} driver expected after {{time}}",
  "dispatch.phone.headline.lateSuffix_other": ", {{count}} drivers expected after {{time}}",
  "dispatch.phone.hero.lateSub_one": "By {{provider}} ETA · {{count}} stop left · the driver has left with the food; this is a reminder only",
  "dispatch.phone.hero.lateSub_other": "By {{provider}} ETA · {{count}} stops left · the driver has left with the food; this is a reminder only",
  "dispatch.phone.drivers.title": "Drivers",
  "dispatch.phone.drivers.legend": "Expected finish · window ends {{time}}",
  "dispatch.phone.hero.viewDriverStops": "See {{name}}'s route",
  "dispatch.phone.stops.back": "Back",
  "dispatch.phone.stops.lateBanner_one": "{{count}} job expected after {{time}} (the delivery window end)",
  "dispatch.phone.stops.lateBanner_other": "{{count}} jobs expected after {{time}} (the delivery window end)",
  "dispatch.phone.stops.sameAddress_one": "{{count}} job at the same address",
  "dispatch.phone.stops.sameAddress_other": "{{count}} jobs at the same address",
  "dispatch.phone.stops.doneSummary": "{{count}} delivered · latest {{time}}",
  "dispatch.phone.stops.loadFailed": "Could not load the estimated times",
  "dispatch.phone.stops.notFound": "This driver is not on today's deliveries.",
  "dispatch.phone.stopsView.label": "View as",
  "dispatch.phone.stopsView.list": "List",
  "dispatch.phone.stopsView.map": "Map",
  "dispatch.phone.stopsView.mapEmpty": "This driver has no jobs to show on the map.",
  "dispatch.phone.inbox.title_one": "{{count}} item waiting for you",
  "dispatch.phone.inbox.title_other": "{{count}} items waiting for you",
  "dispatch.phone.inbox.empty": "Nothing is waiting for you.",
  "dispatch.phone.inbox.loadError": "Could not load the inbox",
  "dispatch.phone.inbox.openOrder": "Open order",
  "dispatch.phone.inbox.changeJoin": ", ",
  "dispatch.phone.inbox.change.address": "address changed",
  "dispatch.phone.inbox.change.quantity": "quantity changed",
  "dispatch.phone.inbox.change.cancel": "order cancelled",
  "dispatch.phone.inbox.change.other": "other change",
  "dispatch.phone.search.entry": "Order number, customer name, or phone",
  "dispatch.phone.search.inputLabel": "Search delivery jobs",
  "dispatch.phone.search.back": "Back to Now",
  "dispatch.phone.search.today_one": "Today · {{count}} job",
  "dispatch.phone.search.today_other": "Today · {{count}} jobs",
  "dispatch.phone.search.later_one": "Later · {{count}} job",
  "dispatch.phone.search.later_other": "Later · {{count}} jobs",
  "dispatch.phone.search.phoneTail": "phone ending {{tail}}",
  "dispatch.phone.search.empty": "No delivery jobs today or later",
  "dispatch.phone.search.truncated": "Showing the first {{shown}} of {{total}}. Type more to narrow it down.",
  "dispatch.board.focus.badge.gate": "Deadline",
  "dispatch.board.focus.badge.mustFix": "Fix first",
  "dispatch.board.focus.badge.handled": "Handled",
  "dispatch.board.focus.badge.canStart": "Ready to start",
  "dispatch.board.focus.badge.attention": "Attention",
  "dispatch.board.focus.badge.progress": "Progress",
  "dispatch.board.focus.badge.exception": "Exception",
  "dispatch.board.focus.badge.reminder": "Reminder",
  "dispatch.board.focus.gateDispatch.title": "Today {{day}} · dispatch {{from}}–{{to}}",
  "dispatch.board.focus.gateDispatch.titleCutoffOnly": "Today {{day}} · dispatch by {{at}}",
  "dispatch.board.focus.gateDispatch.subSoon_one": "Printout cutoff in {{count}} minute.",
  "dispatch.board.focus.gateDispatch.subSoon_other": "Printout cutoff in {{count}} minutes.",
  "dispatch.board.focus.gateDispatch.subLater": "Printout cutoff at {{at}}.",
  "dispatch.board.focus.gateDispatch.subPackClosed": "Printout cutoff has passed. Dispatch everything by {{at}}.",
  "dispatch.board.focus.gateDispatch.subPastCutoff": "The dispatch cutoff has passed.",
  "dispatch.board.focus.gateDispatch.subByCutoff": "Dispatch everything by {{at}}.",
  "dispatch.board.focus.preflight.title_one": "{{count}} delivery job has a cancelled order",
  "dispatch.board.focus.preflight.title_other": "{{count}} delivery jobs have cancelled orders",
  "dispatch.board.focus.preflight.titleNotFound_one": "{{count}} delivery job has no order",
  "dispatch.board.focus.preflight.titleNotFound_other": "{{count}} delivery jobs have no order",
  "dispatch.board.focus.preflight.titleMixed_one": "{{count}} delivery job has a cancelled or missing order",
  "dispatch.board.focus.preflight.titleMixed_other": "{{count}} delivery jobs have cancelled or missing orders",
  "dispatch.board.focus.preflight.sub": "If you leave them, that dispatch batch fails.",
  "dispatch.board.focus.preflightHandled.title": "Preflight anomalies handled",
  "dispatch.board.focus.preflightHandled.sub_one": "{{count}} delivery job cancelled.",
  "dispatch.board.focus.preflightHandled.sub_other": "{{count}} delivery jobs cancelled.",
  "dispatch.board.focus.gateAssign.title_one": "{{count}} driver task still unassigned in {{provider}}",
  "dispatch.board.focus.gateAssign.title_other": "{{count}} driver tasks still unassigned in {{provider}}",
  "dispatch.board.focus.gateAssign.sub": "Drivers pick up at {{at}}. Assign in {{provider}}.",
  "dispatch.board.focus.printable.title": "{{count}} assigned, ready to print by driver",
  "dispatch.board.focus.printable.subRemaining": "Print the rest after they are assigned.",
  "dispatch.board.focus.printable.subNoneLeft": "Finish printing before the {{at}} pickup.",
  "dispatch.board.focus.unmapped.title_one": "{{count}} stop assigned to a driver not set up here",
  "dispatch.board.focus.unmapped.title_other": "{{count}} stops assigned to drivers not set up here",
  "dispatch.board.focus.unmapped.sub": "Import the drivers from {{provider}}.",
  "dispatch.board.focus.late.title": "{{name}} expected to finish at {{at}}",
  "dispatch.board.focus.late.titleMany_one": "{{count}} driver expected to finish after {{at}}",
  "dispatch.board.focus.late.titleMany_other": "{{count}} drivers expected to finish after {{at}}",
  "dispatch.board.focus.late.sub": "Read-only. Handle it in {{provider}}.",
  "dispatch.board.focus.gateDeliver.title": "Deliver · by {{at}}",
  "dispatch.board.focus.gateDeliver.subEta": "All expected delivered by {{at}}.",
  "dispatch.board.focus.gateDeliver.subReadOnly": "Read-only. Handle it in {{provider}}.",
  "dispatch.board.focus.progress.title": "{{delivered}} / {{total}} delivered",
  "dispatch.board.focus.progress.subDrivers_one": "{{count}} driver on the road.",
  "dispatch.board.focus.progress.subDrivers_other": "{{count}} drivers on the road.",
  "dispatch.board.focus.progress.subClosed": "Today is wrapped up.",
  "dispatch.board.focus.exception.title_one": "{{count}} delivery job in exception",
  "dispatch.board.focus.exception.title_other": "{{count}} delivery jobs in exception",
  "dispatch.board.focus.exception.sub": "Sent to the operator inbox.",
  "dispatch.board.focus.nextBatch.title_one": "{{day}} · {{count}} job still coming in",
  "dispatch.board.focus.nextBatch.title_other": "{{day}} · {{count}} jobs still coming in",
  "dispatch.board.focus.nextBatch.sub_one": "{{count}} job awaiting dispatch now.",
  "dispatch.board.focus.nextBatch.sub_other": "{{count}} jobs awaiting dispatch now.",
  "dispatch.board.focus.straggler.title": "{{count}} still in {{step}}",
  "dispatch.board.focus.straggler.sub": "Past the {{at}} deadline; the rest have moved on.",
  "dispatch.board.loading": "Loading the batch board…",
  "dispatch.board.batchWord.shipping_date": "Delivery date",
  "dispatch.board.batchHint_one": "{{count}} day from today · yesterday on top",
  "dispatch.board.batchHint_other": "{{count}} days from today · yesterday on top",
  "dispatch.board.batchHintShifted_one": "{{count}} day from {{from}}",
  "dispatch.board.batchHintShifted_other": "{{count}} days from {{from}}",
  "dispatch.board.intake": "Orders come in",
  "dispatch.board.intakeWho": "Shopify",
  "dispatch.board.bypass": "Side path",
  "dispatch.board.columnAction.dispatch": "Dispatch",
  "dispatch.board.columnAction.assign_driver": "Assign driver",
  "dispatch.board.columnAction.depart": "Depart (first stop starts)",
  "dispatch.board.columnAction.deliver": "Deliver",
  "dispatch.board.nextGateHint": "Times come from the delivery flow settings",
  "dispatch.board.rowTotal_one": "{{count}} delivery job",
  "dispatch.board.rowTotal_other": "{{count}} delivery jobs",
  "dispatch.board.collapsedWeekend": "{{from}} – {{to}} weekend · no delivery jobs, folded (a day with jobs shows as a normal row)",
  "dispatch.board.copy.anomalies_one": "{{count}} preflight anomaly",
  "dispatch.board.copy.anomalies_other": "{{count}} preflight anomalies",
  "dispatch.board.copy.afterPackaging": "Dispatch after {{at}}",
  "dispatch.board.copy.soldOut_one": "{{count}} product sold out",
  "dispatch.board.copy.soldOut_other": "{{count}} products sold out",
  "dispatch.board.copy.assigning": "Assigning in {{provider}}",
  "dispatch.board.copy.printable": "Ready to print",
  "dispatch.board.copy.lateDrivers": "{{count}} running late",
  "dispatch.board.copy.closed": "Wrapped up",
  "dispatch.board.copy.closedLate_one": "After {{at}}: {{count}} job",
  "dispatch.board.copy.closedLate_other": "After {{at}}: {{count}} jobs",
  "dispatch.board.copy.dispatchWindow": "Dispatch · {{from}}–{{to}}",
  "dispatch.board.copy.dispatchWindowOn": "Dispatch · {{date}} {{from}}–{{to}}",
  "dispatch.board.copy.dispatchWindowSameDay": "Dispatch · same day {{from}}–{{to}}",
  "dispatch.board.copy.dispatchCutoffOnly": "Dispatch · by {{at}}",
  "dispatch.board.copy.dispatchCutoffOnlyOn": "Dispatch · {{date}} by {{at}}",
  "dispatch.board.copy.dispatchCutoffOnlySameDay": "Dispatch · same day by {{at}}",
  "dispatch.board.copy.opensInMinutes_one": "Opens in {{count}} minute · dispatch after the printout cutoff",
  "dispatch.board.copy.opensInMinutes_other": "Opens in {{count}} minutes · dispatch after the printout cutoff",
  "dispatch.board.copy.opensAt": "Opens at {{at}} · dispatch after the printout cutoff",
  "dispatch.board.copy.openUntil": "Open · dispatch by {{at}}",
  "dispatch.board.copy.dispatchPassed": "Past the dispatch cutoff",
  "dispatch.board.copy.dispatchByCutoff": "Dispatch everything by {{at}}",
  "dispatch.board.copy.collecting": "Taking orders",
  "dispatch.board.copy.assignBy": "Assign drivers · before the {{at}} pickup",
  "dispatch.board.copy.assignRemaining": "{{count}} left in {{provider}}",
  "dispatch.board.copy.departAfter": "Depart · after the {{at}} pickup",
  "dispatch.board.copy.departPrintable": "{{count}} ready to print",
  "dispatch.board.copy.deliverBy": "Deliver · by {{at}}",
  "dispatch.board.copy.lateDriversEta_one": "{{count}} driver expected at {{at}}",
  "dispatch.board.copy.lateDriversEta_other": "{{count}} drivers expected at {{at}}",
  "dispatch.board.copy.etaDone": "Expected done by {{at}}",
  "dispatch.pane.countBadge_one": "{{count}} job",
  "dispatch.pane.countBadge_other": "{{count}} jobs",
  "dispatch.pane.empty.title": "{{day}} has no \"{{stage}}\" delivery jobs right now",
  "dispatch.pane.empty.noJobs": "This batch has no delivery jobs yet.",
  "dispatch.pane.empty.allDispatched": "This batch is fully dispatched.",
  "dispatch.pane.empty.notHereYet": "This batch has not reached this step yet, or has already passed it.",
  "dispatch.pane.assignment.import": "Import drivers from Onfleet",
  "dispatch.pane.assignment.importConfirmTitle": "Import drivers from Onfleet?",
  "dispatch.pane.assignment.importConfirm": "This reads the current Onfleet driver roster and updates the local driver list. Nothing is sent to Onfleet.",
  "dispatch.pane.assignment.importDone": "Created {{created}}, updated {{updated}}, invalid {{invalid}}. Driver tasks that got their driver: {{backfilled}}.",
  "dispatch.pane.assignment.importFailed": "Driver import failed",
  "dispatch.pane.assignment.progressTitle": "Driver assignment in Onfleet",
  "dispatch.pane.assignment.progressHint": "Updates on every taskAssigned webhook",
  "dispatch.pane.assignment.progressCount_one": "/ {{count}} driver task has a driver",
  "dispatch.pane.assignment.progressCount_other": "/ {{count}} driver tasks have a driver",
  "dispatch.pane.assignment.openOnfleet": "Assign in Onfleet ↗",
  "dispatch.pane.assignment.unassigned": "Not assigned in Onfleet yet",
  "dispatch.pane.assignment.unmapped": "Assigned, but the driver is not in the local list",
  "dispatch.pane.assignment.stops_one": "{{count}} stop",
  "dispatch.pane.assignment.stops_other": "{{count}} stops",
  "dispatch.pane.assignment.beforePickup": "before {{time}} pickup",
  "dispatch.pane.assignment.newDriverNotImported": "New driver not imported",
  "dispatch.pane.assignment.printTitle": "Printing can start now",
  "dispatch.pane.assignment.printBody": "Delivery jobs that already have a driver are in Ready to depart. Print them by driver now and print the rest after assignment.",
  "dispatch.pane.assignment.goReady": "Print in Ready to depart",
  "dispatch.pane.assignment.loadFailed": "Could not load the assignment progress",
  "dispatch.pane.departure.title": "Print delivery jobs by driver",
  "dispatch.pane.departure.subtitle": "One card per delivery job · 101 × 50 mm · {{perSheet}} per sheet",
  "dispatch.pane.departure.pages_one": "{{count}} sheet",
  "dispatch.pane.departure.pages_other": "{{count}} sheets",
  "dispatch.pane.departure.print": "Print",
  "dispatch.pane.departure.assignedOn": "{{day}} · {{count}} assigned",
  "dispatch.pane.departure.printAll": "Print all {{count}} assigned",
  "dispatch.pane.departure.note": "Printing is not recorded, so this column never ticks off. When the driver starts (first taskStarted), the jobs move to “{{enRoute}}”.",
  "dispatch.pane.departure.printTitle": "Delivery job printout {{day}}",
  "dispatch.pane.departure.empty": "No delivery jobs to print",
  "dispatch.pane.departure.loadFailed": "Could not load the delivery job printout",
  "dispatch.pane.departure.noAccess": "You do not have access to the delivery job printout",
  "dispatch.pane.exception.reason.preflight_order_cancelled": "Order cancelled in Shopify; cancelled at the pre-dispatch check",
  "dispatch.pane.exception.reason.operator_before_dispatch": "Cancelled by an operator before dispatch",
  "dispatch.pane.exception.reason.operator_after_dispatch": "Cancelled by an operator after dispatch; the Onfleet driver task was deleted",
  "dispatch.pane.exception.reason.shopify_order_cancelled": "Order cancelled in Shopify; cancelled automatically",
  "dispatch.pane.exception.reason.shopify_date_removed": "The Shopify order no longer includes this day (edited or refunded); cancelled automatically",
  "dispatch.pane.exception.reason.delivery_failed": "Onfleet reported a failed delivery; sent to the operations inbox",
  "dispatch.pane.exception.reason.unknown": "No reason recorded",
  "dispatch.pane.exception.failedTitle": "When a delivery fails",
  "dispatch.pane.exception.failedBody": ": the delivery job goes to Exception and into the operations inbox (dispatch or delivery failed). Once the driver task is deleted in Onfleet, the job returns to “{{pending}}” and can be moved to another batch.",
  "dispatch.pane.exception.loadFailed": "Could not load exception and cancelled delivery jobs",
  "dispatch.pane.enRoute.etaTodayOnly": "Onfleet ETAs are only available for today.",
  "dispatch.pane.enRoute.kpi.delivered": "Delivered",
  "dispatch.pane.enRoute.kpi.deliveredOf_one": "/ {{count}} delivery job",
  "dispatch.pane.enRoute.kpi.deliveredOf_other": "/ {{count}} delivery jobs",
  "dispatch.pane.enRoute.kpi.drivers_one": "{{count}} driver",
  "dispatch.pane.enRoute.kpi.drivers_other": "{{count}} drivers",
  "dispatch.pane.enRoute.kpi.lateTitle": "Expected after {{time}}",
  "dispatch.pane.enRoute.kpi.lateValue_one": "{{count}} driver",
  "dispatch.pane.enRoute.kpi.lateValue_other": "{{count}} drivers",
  "dispatch.pane.enRoute.kpi.byOnfleetEta": "By Onfleet ETA",
  "dispatch.pane.enRoute.kpi.failed": "Delivery failed",
  "dispatch.pane.enRoute.kpi.byJobStatus": "By delivery job status",
  "dispatch.pane.enRoute.lateBy": "{{count}} min late",
  "dispatch.pane.enRoute.stops_one": "{{done}}/{{count}} stop",
  "dispatch.pane.enRoute.stops_other": "{{done}}/{{count}} stops",
  "dispatch.pane.enRoute.unknownDriver": "Driver not in local list",
  "dispatch.pane.enRoute.readOnlyBefore": "Read only: the driver has left with this load and keeps it to the end. To act on it,",
  "dispatch.pane.enRoute.openOnfleet": "view in Onfleet ↗",
  "dispatch.pane.enRoute.readOnlyAfter": "; changes come back here by webhook.",
  "dispatch.pane.enRoute.loadFailed": "Could not load the drivers on the road.",
  "customer.listTitle": "Customers",
  "customer.listDescription": "Shopify customers synced to the admin console.",
  "product.listTitle": "Products",
  "product.listDescription": "Shopify products available for delivery.",
  "order.listTitle": "Orders",
  "order.listDescription": "Shopify orders and their delivery state.",
  "driver.listTitle": "Drivers",
  "driver.listDescription": "Onfleet delivery drivers.",
  "driverProfiles.label": "Driver profile",
  "driverProfiles.listTitle": "Driver Profiles",
  "driverProfiles.listDescription": "Review learned values and maintain dispatcher corrections used by planning.",
  "driverProfiles.field.driver": "Driver",
  "driverProfiles.field.zones": "Top ZIP weights",
  "driverProfiles.field.dailyRange": "Daily volume range",
  "driverProfiles.field.endAnchor": "End anchor",
  "driverProfiles.field.departureOffset": "Departure offset (minutes)",
  "driverProfiles.field.p25": "P25",
  "driverProfiles.field.median": "Median",
  "driverProfiles.field.p75": "P75",
  "driverProfiles.field.lat": "Latitude",
  "driverProfiles.field.lng": "Longitude",
  "driverProfiles.field.address": "Address",
  "driverProfiles.field.learnedFrom": "Samples and window",
  "driverProfiles.searchPlaceholder": "Search driver profiles...",
  "driverProfiles.coldStart": "Cold start — no learned profile yet",
  "driverProfiles.noSupportedZones": "No ZIP meets minimum support",
  "driverProfiles.zoneWeight": "{{zip}} ×{{weight}}",
  "driverProfiles.dailyRangeValue": "{{p25}}–{{p75}}, median {{median}}",
  "driverProfiles.provenance_one": "{{count}} job · {{start}}–{{end}}",
  "driverProfiles.provenance_other": "{{count}} jobs · {{start}}–{{end}}",
  "driverProfiles.relearn": "Relearn profiles",
  "driverProfiles.relearning": "Learning...",
  "driverProfiles.relearnSuccessTitle": "Profiles learned",
  "driverProfiles.relearnSuccess": "Relearn done. Drivers updated: {{drivers}}. Completed delivery jobs used: {{jobs}}.",
  "driverProfiles.relearnErrorTitle": "Profile learning failed",
  "driverProfiles.noEffective": "No effective profile yet",
  "driverProfiles.corrected": "Corrected",
  "driverProfiles.endAnchorValueWithLabel": "{{label}}",
  "driverProfiles.endAnchorValueCoordsOnly": "{{lat}}, {{longitude}}",
  "driverProfiles.endAnchorAddressPlaceholder": "Enter the driver's customary end-of-shift address",
  "driverProfiles.offsetPositive": "+{{value}} min",
  "driverProfiles.offsetValue": "{{value}} min",
  "driverProfiles.editAria": "Edit overrides for {{driver}}",
  "driverProfiles.editFormAria": "Override editor for {{driver}}",
  "driverProfiles.save": "Save overrides",
  "driverProfiles.saving": "Saving...",
  "driverProfiles.clearRestore": "Clear and restore learned value",
  "driverProfiles.clearAria": "Clear {{field}} override for {{driver}}",
  "driverProfiles.clearField.zones": "zones",
  "driverProfiles.clearField.dailyRange": "daily range",
  "driverProfiles.clearField.endAnchor": "end anchor",
  "driverProfiles.clearField.departureOffset": "departure offset",
  "driverProfiles.zoneZipAria": "ZIP {{index}}",
  "driverProfiles.zoneWeightAria": "Weight {{index}}",
  "driverProfiles.removeZoneAria": "Remove zone {{index}}",
  "driverProfiles.addZone": "Add ZIP",
  "driverProfiles.validation.zones": "Each ZIP must have five digits and a weight greater than 0 and at most 1.",
  "driverProfiles.validation.dailyRange": "P25, median, and P75 must be positive integers in ascending order.",
  "driverProfiles.validation.endAnchor": "Enter a valid latitude, longitude, and label of at most 120 characters.",
  "driverProfiles.validation.departureOffset": "Departure offset must be an integer from -120 to 120.",
  "driverProfiles.saveSuccessTitle": "Profile corrected",
  "driverProfiles.saveSuccess": "The effective profile has been refreshed.",
  "driverProfiles.saveErrorTitle": "Could not save profile correction",
  "driverProfiles.empty": "No drivers found",
  "ingredient.listTitle": "Ingredients",
  "ingredient.listDescription": "Raw ingredients used across recipes.",
  "supplier.listTitle": "Suppliers",
  "supplier.listDescription": "Ingredient suppliers and their contact details.",
  "dish.listTitle": "Dishes",
  "dish.listDescription": "Menu dishes and their recipes.",
  "combo.listTitle": "Combos",
  "combo.listDescription": "Combo bundles composed of dishes.",
  "job.listTitle": "Delivery Jobs",
  "job.listDescription": "Dispatch and track.",
  "webhook.listTitle": "Webhook Events",
  "webhook.listDescription": "Inbound Shopify and Onfleet webhook events.",
  "menu_plan.listTitle": "Menu Plans",
  "menu_plan.listDescription": "Weekly menu plans and their published items.",
  "nav.tenantSettings": "Integrations",
  "nav.deliveryFlowSettings": "Delivery flow",
  "auditWebhooks.tab.operations": "Operation Audit",
  "auditWebhooks.tab.changes": "Data Changes",
  "auditWebhooks.tab.events": "Webhook Events",
  "auditWebhooks.tab.failures": "Webhook Failures",
  "auditWebhooks.tab.health": "Webhook Health",
  "webhookFailures.row.delete": "Delete",
  "webhookFailures.detail.title": "Failure detail",
  "webhookFailures.detail.status": "Status",
  "webhookFailures.detail.resolved": "Resolved",
  "webhookFailures.detail.unresolved": "Unresolved",
  "webhookFailures.detail.traceId": "Trace ID",
  "webhookFailures.detail.rawPayload": "Raw payload",
  "webhookFailures.detail.relatedEvent": "Related webhook event",
  "webhookFailures.detail.viewEvent": "View event",
  "webhookFailures.detail.noRelatedEvent": "No related webhook event",
  "webhookFailures.selfHeal.self_healed": "Self-healed",
  "webhookFailures.selfHeal.needs_review": "Needs review",
  "webhookFailures.detail.selfHeal": "Self-heal check",
  "webhookFailures.detail.selfHealCriterion.provider_event_id": "The same provider event was stored successfully later.",
  "webhookFailures.detail.selfHealCriterion.payload_hash": "A later delivery with an identical payload was stored successfully.",
  "webhookFailures.detail.selfHealNeedsReview": "No successful delivery matching this failure was found.",
  "webhookFailures.detail.viewMatchedEvent": "View the successful event",
  "webhookFailures.detail.diagnosis": "Error & payload",
  "webhookFailures.detail.loading": "Loading detail…",
  "webhookFailures.detail.loadError": "Could not load failure detail. Detail: {{detail}}",
  "webhookFailures.detail.openFullPage": "Open full page",
  "webhookFailures.detail.backToList": "Back to failures",
  "webhookFailures.detail.notFound": "This webhook failure could not be found.",
  "webhookFailures.delete.confirmTitle": "Delete failure?",
  "webhookFailures.delete.confirmMessage": "This permanently removes the failure record. This action cannot be undone.",
  "webhookFailures.delete.success.title": "Deleted",
  "webhookFailures.delete.success.body": "Failure permanently removed.",
  "webhookFailures.delete.error.title": "Delete failed",
  "webhookFailures.delete.error.unknown": "Could not delete failure. Detail: {{detail}}",
  "webhookFailures.bulkDelete.submit": "Delete selected",
  "webhookFailures.bulkDelete.limitHint": "At most {{max}} can be deleted at once; only the first {{max}} will be removed.",
  "webhookFailures.bulkDelete.confirmTitle_one": "Delete {{count}} failure?",
  "webhookFailures.bulkDelete.confirmTitle_other": "Delete {{count}} failures?",
  "webhookFailures.bulkDelete.confirmMessage": "This permanently removes the selected failure records. This action cannot be undone.",
  "webhookFailures.bulkDelete.success.title": "Bulk delete complete",
  "webhookFailures.bulkDelete.success.summary_one": "Deleted {{count}} failure.",
  "webhookFailures.bulkDelete.success.summary_other": "Deleted {{count}} failures.",
  "webhookFailures.bulkDelete.error.title": "Bulk delete failed",
  "webhookFailures.bulkDelete.error.unknown": "Could not delete selected failures. Detail: {{detail}}",
  "webhookFailures.purge.button": "Clear all",
  "webhookFailures.purge.confirmTitle": "Clear all failures?",
  "webhookFailures.purge.confirmMessage": "This permanently deletes ALL webhook failure records — including every already-resolved failure from history, not only the {{count}} currently unresolved. The full history may be far larger than that. This action cannot be undone.",
  "webhookFailures.purge.success.title": "Cleared",
  "webhookFailures.purge.success.summary_one": "Deleted {{count}} failure.",
  "webhookFailures.purge.success.summary_other": "Deleted {{count}} failures.",
  "webhookFailures.purge.error.title": "Clear all failed",
  "webhookFailures.purge.error.unknown": "Could not clear failures. Detail: {{detail}}",
  "job.field.driverName": "Driver",
  "job.field.driverId": "Driver ID",
  "nav.analytics": "Analytics",
  "analytics.page.title": "Analytics",
  "analytics.page.subtitle": "Weekly business reports and ad-hoc analyses.",
  "analytics.details.title": "Detailed data",
  "analytics.sync.staleTitle": "Analytics data may be stale",
  "analytics.sync.staleDescription": "The latest upstream sync did not succeed. Last successful sync: {{time}}.",
  "analytics.sync.unavailableTitle": "Analytics freshness is unavailable",
  "analytics.sync.unavailableDescription": "No successful upstream sync has been recorded. Reports must not be treated as current.",
  "analytics.freshness.current": "Data synced",
  "analytics.freshness.stale": "Data may be stale",
  "analytics.generate.title": "Generate ad-hoc report",
  "analytics.generate.selectRange": "Select a date range",
  "analytics.generate.button": "Generate report",
  "analytics.generate.runningShort": "Generating…",
  "analytics.generate.successTitle": "Report generated",
  "analytics.generate.successMessage": "The ad-hoc report is ready to read.",
  "analytics.generate.errorTitle": "Report generation failed",
  "analytics.generate.errorMessage": "The report could not be generated. Check sync freshness and try again.",
  "analytics.archive.loading": "Loading analytics reports…",
  "analytics.archive.error": "Analytics reports could not be loaded.",
  "analytics.archive.emptyDescription": "A report will appear after scheduled or ad-hoc generation succeeds.",
  "analytics.report.generatedAt": "Generated {{time}}",
  "analytics.report.loading": "Loading report…",
  "analytics.report.error": "This report could not be loaded.",
  "analytics.period.weekly": "Weekly",
  "analytics.period.adhoc": "Ad-hoc",
  "analytics.value.notAvailable": "Not available",
  "analytics.metrics.growth": "Growth",
  "analytics.metrics.metric": "Metric",
  "analytics.metrics.orders": "Orders",
  "analytics.metrics.revenue": "Revenue",
  "analytics.metrics.orderingCustomers": "Ordering customers",
  "analytics.metrics.current": "Current period",
  "analytics.metrics.previousPeriod": "Previous period",
  "analytics.metrics.periodChange": "Period change",
  "analytics.metrics.previousYear": "Previous year",
  "analytics.metrics.yearChange": "Year change",
  "analytics.metrics.activation": "Activation",
  "analytics.metrics.cohortRange": "Cohort: {{start}} to {{end}}",
  "analytics.metrics.attained": "Customers that attained the target: {{attained}} of {{total}}.",
  "analytics.metrics.activationRate": "Activation rate: {{value}}",
  "analytics.metrics.matching": "Menu matching",
  "analytics.metrics.matchingCounts": "Active customers covered: {{covered}} of {{active}} · Dishes offered: {{dishes}}.",
  "analytics.metrics.coverageRate": "Coverage rate: {{value}}",
  "analytics.metrics.uncovered": "Uncovered customers: {{count}}",
  "analytics.metrics.retention": "Retention",
  "analytics.metrics.activeCore": "Active core customers: {{count}}",
  "analytics.metrics.checkpoint": "Checkpoint",
  "analytics.metrics.atRisk": "At risk",
  "analytics.metrics.eventualReturn": "Eventual return",
  "analytics.metrics.rate": "Rate",
  "analytics.metrics.miniChart": "Mini chart",
  "analytics.metrics.days_one": "{{count}} day",
  "analytics.metrics.days_other": "{{count}} days",
  "analytics.metrics.alerts": "Alerts",
  "analytics.metrics.watchlist": "Watchlist customers: {{count}}",
  "analytics.metrics.leverage": "Order leverage",
  "analytics.metrics.orderCount": "Orders: {{count}}",
  "analytics.metrics.itemCount": "Items: {{count}}",
  "analytics.metrics.averageItems": "Average items per order: {{value}}",
  "analytics.metrics.averageItemsLabel": "Average items per order",
  "analytics.narrative.title": "AI analysis",
  "analytics.narrative.empty": "No business interpretation was archived; rely on the deterministic metrics for this report.",
  "analytics.trace.title": "Calculation trace",
  "analytics.trace.ariaLabel": "Analytics call trace",
  "analytics.list.label": "Reports",
  "analytics.list.weekly": "Weekly reports",
  "analytics.list.adhoc": "Ad-hoc reports",
  "analytics.list.generatedOn": "Generated {{date}}",
  "analytics.archive.emptyTitle": "No reports yet",
  "analytics.report.weeklyLabel": "Week {{week}}, {{year}} · {{range}}",
  "analytics.report.adhocLabel_one": "{{range}} · {{count}} day",
  "analytics.report.adhocLabel_other": "{{range}} · {{count}} days",
  "analytics.delete.button": "Delete",
  "analytics.delete.ariaLabel": "Delete {{label}}",
  "analytics.delete.confirmTitle": "Delete this ad-hoc report?",
  "analytics.delete.confirmMessage": "“{{label}}” will be removed. You can generate a report for the same dates again later.",
  "analytics.delete.successTitle": "Report deleted",
  "analytics.delete.errorTitle": "The report could not be deleted",
  "analytics.delete.errorMessage": "Try again later.",
  "analytics.generate.description": "Choose the dates to analyse. Generation can take a few minutes.",
  "analytics.generate.blockedStale": "Generation is paused: the last upstream sync failed, so the data may be stale.",
  "analytics.generate.blockedUnavailable": "Generation is paused: no upstream sync has succeeded yet.",
  "analytics.generate.blockedRange": "Choose a start date and an end date.",
  "analytics.performance.title": "This period",
  "analytics.performance.periodChange": "vs prior",
  "analytics.performance.yearChange": "vs last year",
  "analytics.performance.periodWindow": "Prior: {{range}}",
  "analytics.performance.yearWindow": "Last year: {{range}}",
  "analytics.performance.noComparison": "No comparison",
  "analytics.performance.itemsSold_one": "{{n}} item sold",
  "analytics.performance.itemsSold_other": "{{n}} items sold",
  "analytics.health.title": "Customer health",
  "analytics.health.asOf": "Snapshot as of {{time}}. It does not follow the report period, and later data such as refunds can change it.",
  "analytics.health.activation": "Activation rate",
  "analytics.health.activationDetail": "New customers that reached the first-month goal: {{attained}} / {{total}}",
  "analytics.health.activationCohort": "Cohort {{range}}",
  "analytics.health.coverage": "Menu coverage",
  "analytics.health.coverageDetail": "Active customers covered: {{covered}} / {{active}} · Dishes offered: {{dishes}}",
  "analytics.health.retention": "Core-customer return curve",
  "analytics.health.retentionDescription_one": "Eventual return rate at each checkpoint · {{n}} active core customer",
  "analytics.health.retentionDescription_other": "Eventual return rate at each checkpoint · {{n}} active core customers",
  "analytics.health.retentionRate": "Return rate",
  "analytics.health.retentionSample": "n = {{n}}",
  "analytics.health.watchlist": "Churn watchlist",
  "analytics.health.watchlistCustomers": "customers",
  "analytics.health.watchlistSpend": "Lifetime spend",
  "analytics.health.watchlistSpendHint": "What these customers have spent in total so far. It is not an amount at risk.",
  "analytics.narrative.failureTitle": "The AI analysis for this report was not generated",
  "analytics.narrative.failureHint": "The metrics above are calculated directly and are not affected.",
  "analytics.narrative.failure.credentialMissing": "The AI service credential is not configured.",
  "analytics.narrative.failure.apiError": "The AI service returned an error.",
  "analytics.narrative.failure.refusal": "The AI model declined to write the analysis.",
  "analytics.narrative.failure.malformedOutput": "The AI output was not in the expected format, so it was discarded.",
  "analytics.narrative.failure.tokenBudgetExhausted": "The AI model used up its output budget before it finished.",
  "analytics.narrative.failure.untraceableNumber": "The analysis quoted a number the metrics do not support, so it was discarded.",
  "analytics.narrative.failure.missingFollowup": "The analysis did not follow up the previous recommendations, so it was discarded.",
  "analytics.narrative.failure.unknown": "The AI analysis failed. See the calculation trace for details.",
  "analytics.metrics.lifetimeSpend": "Lifetime spend: {{value}}",
  "app.newVersion.message": "A newer version of this console has been deployed. Reload to get it.",
  "app.newVersion.reload": "Reload now",
  "tenants.loading": "Loading…",
  "tenants.settingsPage.title": "Integrations and settings",
  "tenants.settingsPage.subtitle": "Credentials and settings of the current tenant.",
  "tenants.integrations.loadError": "Could not load the integrations.",
  "tenants.integrations.shopify.title": "Shopify",
  "tenants.integrations.onfleet.title": "Onfleet",
  "tenants.integrations.shopify.liveWarning": "Saving immediately replaces the Shopify credentials production uses for live traffic.",
  "tenants.integrations.onfleet.liveWarning": "Saving immediately replaces the Onfleet credentials production uses for live traffic. Onfleet only checks that the key works, not that it belongs to the same organization.",
  "tenants.integrations.field.verifiedAt": "Verified",
  "tenants.integrations.source.tenant": "From tenant configuration",
  "tenants.integrations.source.none": "Not configured",
  "tenants.integrations.shopify.kind.label": "Credential type",
  "tenants.integrations.shopify.kind.legacy_token": "Admin API access token",
  "tenants.integrations.shopify.kind.client_credentials": "Client credentials",
  "tenants.integrations.shopify.secretRequired": "Fill in the API secret, the webhook secret, or both: webhooks cannot be verified without one.",
  "tenants.integrations.save": "Verify and save",
  "tenants.integrations.saving": "Verifying…",
  "tenants.integrations.saved": "Credentials verified and saved.",
  "tenants.integrations.saveFailed": "Could not save: {{message}}",
  "tenants.integrations.required": "Fill in every required field.",
  "tenants.integrations.registerWebhooks": "Register webhooks",
  "tenants.integrations.registering": "Registering…",
  "tenants.integrations.registerHint": "Available once credentials are saved here.",
  "tenants.integrations.registerFailed": "Could not register webhooks: {{message}}",
  "tenants.integrations.webhooks.created": "Created",
  "tenants.integrations.webhooks.existing": "Already present",
  "tenants.integrations.webhooks.none": "None",
  "tenants.integrations.edit": "Edit credentials",
  "tenants.integrations.cancel": "Cancel",
  "tenants.integrations.notSet": "Not set",
  "tenants.integrations.fieldName.shopDomain": "Shop domain",
  "tenants.integrations.fieldName.accessToken": "Access token",
  "tenants.integrations.fieldName.apiSecret": "API secret",
  "tenants.integrations.fieldName.webhookSecret": "Webhook secret",
  "tenants.integrations.fieldName.clientId": "Client ID",
  "tenants.integrations.fieldName.clientSecret": "Client secret",
  "tenants.integrations.fieldName.apiKey": "API key",
  "tenants.integrations.fieldName.organizationId": "Organization ID",
  "tenants.integrations.webhooks.title": "Webhook subscriptions",
  "tenants.integrations.webhooks.topic": "Topic",
  "tenants.integrations.webhooks.url": "URL",
  "tenants.integrations.webhooks.target": "Target",
  "tenants.integrations.webhooks.ours": "This site",
  "tenants.integrations.webhooks.elsewhere": "Elsewhere",
  "tenants.integrations.webhooks.empty": "No subscriptions.",
  "tenants.integrations.webhooks.missing": "Not yet subscribed here",
  "tenants.integrations.webhooks.loading": "Loading subscriptions…",
  "tenants.integrations.webhooks.loadFailed": "Could not list the subscriptions: {{message}}",
  "tenants.integrations.webhooks.shopifyAdminNote": "Subscriptions created by hand in the Shopify admin are not visible here.",
  "tenants.settings.loadError": "Could not load the tenant settings.",
  "tenants.settings.packagingCutoffTime": "Packing cutoff time",
  "tenants.settings.epochDate": "Backfill start date",
  "tenants.settings.source.tenant": "From tenant settings",
  "tenants.settings.source.legacy": "Not set",
  "tenants.settings.save": "Save",
  "tenants.settings.saving": "Saving…",
  "tenants.settings.saved": "Settings saved.",
  "tenants.settings.saveFailed": "Could not save the settings: {{message}}",
  "tenants.branding.loadError": "Could not load the branding.",
  "tenants.branding.name": "Organization name",
  "tenants.branding.save": "Save name",
  "tenants.branding.saving": "Saving…",
  "tenants.branding.saved": "Name saved.",
  "tenants.branding.saveFailed": "Could not save the name: {{message}}",
  "tenants.branding.logo": "Logo",
  "tenants.branding.logoPreview": "Logo preview",
  "tenants.branding.noLogo": "No logo set. The Fastcade logo is shown.",
  "tenants.branding.logoHint": "PNG, JPEG or WebP, at most 256 KB. Shown at the top left of the sidebar.",
  "tenants.branding.logoTypeInvalid": "Choose a PNG, JPEG or WebP image.",
  "tenants.branding.logoTooLarge": "The image is larger than 256 KB.",
  "tenants.branding.uploading": "Uploading…",
  "tenants.branding.uploadFailed": "Could not upload the logo: {{message}}",
  "tenants.branding.removeLogo": "Remove logo",
  "tenants.branding.removeFailed": "Could not remove the logo: {{message}}",
  "tenants.sections.nav": "Settings sections",
  "tenants.sections.branding.title": "Branding",
  "tenants.sections.branding.description": "The organization name and logo shown at the top left of the sidebar.",
  "tenants.sections.integrations.title": "Integrations",
  "tenants.sections.integrations.description": "Shopify and Onfleet credentials production uses for live traffic.",
  "tenants.sections.operations.title": "Operations",
  "tenants.sections.operations.description": "Parameters of packing and backfill. An empty value falls back to the legacy configuration.",
  "tenants.integrations.webhooks.summary_one": "{{count}} subscription · {{missing}} not yet subscribed here",
  "tenants.integrations.webhooks.summary_other": "{{count}} subscriptions · {{missing}} not yet subscribed here",
  "tenants.integrations.webhooks.summaryFailed": "Could not load the list",
  "tenants.settings.edit": "Edit {{label}}",
  "tenants.settings.cancel": "Cancel",
  "tenants.settings.resetToDefault": "Reset to default",
  "deliveryFlow.page.title": "Delivery flow",
  "deliveryFlow.page.headline": "The delivery flow sets the rows, columns and deadlines of the logistics board",
  "deliveryFlow.page.subtitle": "A row is a batch, a column is a step (how far a delivery job has gone), and an arrow between steps is who moves it on, and when. One per tenant.",
  "deliveryFlow.loadError": "Could not load the delivery flow.",
  "deliveryFlow.sections.template.title": "Template",
  "deliveryFlow.sections.template.description": "The template decides the batches, the steps and the actions.",
  "deliveryFlow.sections.batch.title": "Batches",
  "deliveryFlow.sections.batch.description": "A row of the logistics board is a batch: delivery jobs that move through the flow together.",
  "deliveryFlow.sections.columns.title": "Steps",
  "deliveryFlow.sections.columns.description": "How far a delivery job has gone. Each step is one column of the board and comes from the delivery job status and the driver data; no new status is added.",
  "deliveryFlow.sections.actions.title": "Actions",
  "deliveryFlow.sections.actions.description": "The arrows between steps: who moves a delivery job on, and how the board learns that it happened.",
  "deliveryFlow.sections.gates.title": "Deadlines",
  "deliveryFlow.sections.gates.description": "Time rules. A reminder does not block anything, it only reminds; a promise is made to the customer and is not a system rule.",
  "deliveryFlow.sections.integrations.title": "Integrations",
  "deliveryFlow.sections.integrations.description": "Who moves things on outside the system",
  "deliveryFlow.integration.orders": "Order source",
  "deliveryFlow.integration.ordersValue": "Shopify order webhooks (orders/create, paid, updated, cancelled)",
  "deliveryFlow.integration.delivery": "Delivery",
  "deliveryFlow.integration.deliveryValue": "Onfleet (creates driver tasks, sends status webhooks)",
  "deliveryFlow.integration.writeback": "Write-back",
  "deliveryFlow.integration.writebackValue": "Shopify fulfillment record, on delivery",
  "deliveryFlow.preview.label": "Preview · how the logistics board will look",
  "deliveryFlow.preview.batchColumn": "Batch",
  "deliveryFlow.preview.note": "Rows = board range; rest days are drawn as gap rows. Columns and arrows come from the Steps and Actions sections.",
  "deliveryFlow.row.template": "Template",
  "deliveryFlow.template.hgs_same_day": "Same-day delivery",
  "deliveryFlow.templateDescription.hgs_same_day": "By delivery date · own drivers · Onfleet",
  "deliveryFlow.templateInUse": "In use",
  "deliveryFlow.row.batch": "Batch by",
  "deliveryFlow.batch.shipping_date": "Delivery date: every delivery job has a delivery date",
  "deliveryFlow.row.boardRange": "Board range",
  "deliveryFlow.range.days_one": "{{count}} day",
  "deliveryFlow.range.days_other": "{{count}} days",
  "deliveryFlow.row.calendar": "Delivery calendar",
  "deliveryFlow.calendar.invalid": "Select at least one delivery day. Not every day can be a rest day.",
  "deliveryFlow.calendar.note": "Rest days show on the logistics board as empty “no delivery” rows; a rest day that has delivery jobs is marked “Rest day” on its row. Orders are still accepted.",
  "deliveryFlow.weekday.1": "Mon",
  "deliveryFlow.weekday.2": "Tue",
  "deliveryFlow.weekday.3": "Wed",
  "deliveryFlow.weekday.4": "Thu",
  "deliveryFlow.weekday.5": "Fri",
  "deliveryFlow.weekday.6": "Sat",
  "deliveryFlow.weekday.7": "Sun",
  "deliveryFlow.columnRule.awaiting_dispatch": "Status is Planned.",
  "deliveryFlow.columnRule.awaiting_assignment": "Dispatched, with no driver yet.",
  "deliveryFlow.columnRule.awaiting_departure": "Dispatched with a driver who has not started the first stop of the day.",
  "deliveryFlow.columnRule.en_route": "In Progress; or dispatched with a driver who has started the first stop of the day (Onfleet starts one stop at a time).",
  "deliveryFlow.columnRule.delivered": "Completed.",
  "deliveryFlow.columnRule.exception_or_cancelled": "Exception or Cancelled.",
  "deliveryFlow.action.dispatch": "Dispatch",
  "deliveryFlow.action.assign_driver": "Assign driver",
  "deliveryFlow.action.depart": "Depart",
  "deliveryFlow.action.deliver": "Deliver",
  "deliveryFlow.executor.operator": "Us",
  "deliveryFlow.executor.onfleet": "Onfleet",
  "deliveryFlow.executor.driver": "Driver",
  "deliveryFlow.actionSignal.dispatch": "Dispatch (POST /api/dispatch/run)",
  "deliveryFlow.actionSignal.assign_driver": "Onfleet taskAssigned webhook",
  "deliveryFlow.actionSignal.depart": "The driver starts the first stop (taskStarted)",
  "deliveryFlow.actionSignal.deliver": "taskCompleted, written back to the Shopify delivery record",
  "deliveryFlow.row.timezone": "Time zone",
  "deliveryFlow.gate.packaging_cutoff": "Delivery job printout cutoff",
  "deliveryFlow.gate.dispatch_cutoff": "Dispatch cutoff",
  "deliveryFlow.gate.delivery_window": "Delivery times",
  "deliveryFlow.window.start": "Driver task earliest delivery",
  "deliveryFlow.window.end": "Delivery window ends",
  "deliveryFlow.window.invalid": "Set both times, with the earliest delivery before the end of the delivery window.",
  "deliveryFlow.gateClass.hint": "Reminder",
  "deliveryFlow.gateClass.mandatory": "Enforced",
  "deliveryFlow.gateClass.dispatch": "{{category}} and intake rule",
  "deliveryFlow.gate.dispatch_cutoff.note": "Dispatch is never blocked; the dispatch preview only warns “past cutoff”. At order intake, same-day items past this time do not become delivery jobs.",
  "deliveryFlow.gateClass.promise": "Promise",
  "deliveryFlow.source.default": "Default",
  "tenants.branding.editName": "Edit name",
  "tenants.branding.cancel": "Cancel",
  "tenants.branding.changeLogo": "Change",
  "tenants.integrations.editNote": "Saving verifies the new credentials first and replaces the whole set. Saved secrets are never shown again.",
  "tenants.integrations.shopify.secretHint": "Fill in at least one of the API secret and the webhook secret.",
  "overview.headline": "Today {{delivered}} / {{total}} delivered; tomorrow {{tomorrow}} {{pending}} awaiting dispatch",
  "overview.headlineNoDispatch": "Site status",
  "overview.subtitle": "How the whole site stands right now. Each card links to the page where you act on it.",
  "overview.loading": "Loading…",
  "overview.loadError": "Failed to load",
  "overview.days.title": "Delivery days",
  "overview.days.open": "Go to dispatch",
  "overview.days.empty": "No delivery jobs",
  "overview.days.delivered": "{{delivered}} / {{total}} delivered",
  "overview.days.total_one": "{{count}} job",
  "overview.days.total_other": "{{count}} jobs",
  "overview.inbox.open": "Open",
  "overview.outcomes.title": "Last 3 delivery days",
  "overview.outcomes.subtitle": "Delivered · late after {{at}}",
  "overview.outcomes.inProgress": "In progress · {{delivered}} / {{total}}",
  "overview.outcomes.done": "{{delivered}} · {{late}} late",
  "overview.outcomes.empty": "No delivery days yet",
  "overview.integrations.title": "Integrations",
  "overview.integrations.open": "Integrations & settings",
  "overview.integrations.lastWebhook": "Last webhook {{ago}}",
  "overview.integrations.noWebhook": "No webhook in 24 hours",
  "overview.integrations.verified": "Credentials verified {{date}}",
  "overview.integrations.unverified": "Credentials not verified",
  "overview.demand.title": "Tomorrow {{date}} demand",
  "overview.demand.empty": "No demand for tomorrow yet",
  "overview.days.tomorrow": "Tomorrow",
  "overview.inbox.sub.post_cutoff_order_change": "The order changed after the delivery job printout cutoff",
  "overview.inbox.sub.post_dispatch_cancellation": "After dispatch the order was cancelled, refunded, or its quantity / address changed",
  "overview.inbox.sub.dispatch_failed": "Onfleet failed to create / cancel the driver task, or the driver task failed",
  "overview.demand.subtitle": "Units · from today’s demand",
  "overview.demand.shopify.consistent": "Matches Shopify",
  "overview.demand.shopify.mismatch_one": "{{count}} product differs from Shopify",
  "overview.demand.shopify.mismatch_other": "{{count}} products differ from Shopify",
  "overview.demand.shopify.unavailable": "Shopify check unavailable",
  "search.placeholder": "Order no., delivery job, driver task short ID",
  "search.ariaLabel": "Search order no., delivery job, driver task short ID",
  "search.group.orders": "Orders",
  "search.group.jobs": "Delivery jobs",
  "search.group.tasks": "Driver tasks",
  "search.taskJobs_one": "{{count}} delivery job",
  "search.taskJobs_other": "{{count}} delivery jobs",
  "search.minChars": "Type at least 2 characters",
  "search.loading": "Searching…",
  "search.empty": "No matching numbers",
  "search.groupError": "This search failed",
  "search.footer": "↑↓ select · ↵ open · Esc close"
}
